/* eslint-disable camelcase */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router";
import axios from "axios";
import utils from "@utils";
import {
	GenericService,
	JurisdictionService,
	SignUpService,
	StripeService,
	RegionSearchService,
} from "@services";
import { StateSelection } from "@components/common";
import ProgressButton from "react-progress-button";
import { STATIC_URLS, MASK_VALUE, BANK_ACCOUNT_TYPES, JURISDICTION_FEE_TYPES } from "@constants";
import MaskedInput from "react-text-mask";
import classNames from "classnames";
import {
	CreateJurisdictionModal,
	Image,
	AsyncSelect,
	ReactSelect,
	Tooltip,
} from "../../../components";
import TextLogo from "../../../images/logo-text.svg";
import IconLogo from "../../../images/logo-icon.svg";

import "./SignUpLea.scss";

class SignUpLea extends Component {
	constructor(props) {
		super(props);
		this.state = {
			step: 0,
			subStep: 1,
			activeForm: "personalInfo",
			buttonState: "",
			signUpToken: "",
			vehicleTypes: [],
			locationTypes: [],
			counties: [],
			loadingCounties: false,
			jurisdictions: [],
			loadingJurisdictions: false,
			showVehicleFees: true,
			showGeneralFees: true,
			showAllowedLocations: true,
			allowedLocations: [],
			validPhotoIdSelected: true,
			agreeToTerms: false,
			showJurisdictionModal: false,
			personalInfo: {
				firstName: "",
				lastName: "",
				email: "",
				phone: "",
				password: "",
				confirmPassword: "",
				title: "",
				errors: {
					firstName: false,
					lastName: false,
					email: false,
					phone: false,
					password: false,
					confirmPassword: false,
					title: false,
				},
			},
			departmentInfo: {
				state: "",
				countyId: "",
				countyName: "",
				jurisdictionId: "",
				jurisdictionName: "",
				errors: {
					state: false,
					countyId: false,
					jurisdictionId: false,
					agreeToTerms: false,
				},
			},
			bankAccountInfo: {
				account_holder_name: "",
				routing_number: "",
				account_number: "",
				account_number_confirm: "",
				account_holder_type: "1",
				id_number: "",
				dateOfBirth: "",
				tax_id: "",
				name: "",
				line1: "",
				city: "",
				state: "",
				postal_code: "",
				photoId: "",
				photoPreview: "",
				fullyAuthorized: "",
				errors: {
					account_holder_name: false,
					routing_number: false,
					account_number: false,
					account_number_confirm: false,
					account_holder_type: false,
					id_number: false,
					dateOfBirth: false,
					tax_id: false,
					name: false,
					line1: false,
					city: false,
					state: false,
					postal_code: false,
					photoId: false,
					photoPreview: false,
					phone: false,
					fullyAuthorized: false,
				},
			},
			invoicingInfo: {
				TransferPaymentToJurisdiction: false,
				TransferCoordinatorPaymentToJurisdiction: false,
				IsOfficerInvoiceApprovalRequired: false,
				OfficerInsuranceOptIn: false,
				jurisdictionFees: {
					generalFees: [],
					vehicleFees: [],
				},
				errors: {
					TransferPaymentToJurisdiction: false,
					TransferCoordinatorPaymentToJurisdiction: false,
					IsOfficerInvoiceApprovalRequired: false,
					OfficerInsuranceOptIn: false,
					generalFees: false,
					vehicleFees: false,
				},
			},
			agencyRules: {
				IsJobLocationTypeRestricted: false,
				RestrictedJobLocationTypes: [],
				IsJobLocationApprovalRequired: false,
				errors: {
					RestrictedJobLocationTypes: false,
				},
			},
			officerRules: {
				limitedHours: false,
				MaxWeeklyHoursType: "",
				MaxWeeklyHours: "",
				ExtraDutyApprovalRequired: false,
				JobAutoAssignType: "1",
				JobAutoAssignHoursSpan: "",
				JobAutoAssignYearToDateSpan: true,
				JobAutoAssignJobCountDaysSpan: "",
				JobCallOffType: "",
				JobCallOffReplacementTypes: [],
				JobCallOffExpirationMinutes: 1440,
				JobRestrictionType: 0,
				JobLocationRestrictedCities: [],
				JobLocationRestrictedCounties: [],
				signUpPeriodHoursMultiplier: "1",
				errors: {},
			},
		};
		this.USStates = [];
		this.departmentStateSelection = React.createRef();
		this.accountStateSelection = React.createRef();
		this.stepArray = ["Personal Info", "Department Info", "Payment/Invoicing", "Rules"];
		this.signUpPeriodTimeTypeOptions = [
			{ label: "hours", value: 1 },
			{ label: "days", value: 24 },
		];
		this.callOffTimes = [
			{ value: 4320, label: "3 days" },
			{ value: 2880, label: "2 days" },
			{ value: 1440, label: "24 hours" },
			{ value: 1080, label: "18 hours" },
			{ value: 720, label: "12 hours" },
			{ value: 360, label: "6 hours" },
			{ value: 180, label: "3 hours" },
			{ value: 60, label: "1 hour" },
			{ value: 45, label: "45 mins" },
			{ value: 30, label: "30 mins" },
			{ value: 15, label: "15 mins" },
			{ value: 0, label: "None" },
		];
		this.locationCancelToken = undefined;
	}

	componentDidMount() {
		const {
			location: { search },
		} = this.props;
		if (search) {
			// retrieve the value passed into the referrer url param
			const params = new URLSearchParams(search);
			const value = params.get("referrer");
			localStorage.setItem("referrer", value);
		}
		this.getVehicleTypes();
		this.getLocationTypes();
		this.getUSStates();
	}

	/** Retrieves a list of vehicle types */
	getVehicleTypes = () => {
		const { lang } = global;
		GenericService.getVehicleTypes()
			.then(({ data }) => {
				this.setState({ vehicleTypes: data });
			})
			.catch(() => {
				utils.notify({
					type: "error",
					message: lang.t("Error loading Vehicle Types"),
					timeOut: 1500,
				});
			});
	};

	/** Retrieves a list of location types */
	getLocationTypes = () => {
		const { lang } = global;

		GenericService.getLocationTypes()
			.then(({ data }) => {
				const locationTypes = data.map(({ Id: value, Name: label }) => ({ value, label }));
				this.setState({ locationTypes });
			})
			.catch(() => {
				utils.notify({
					type: "error",
					message: lang.t("Error loading location types"),
					timeOut: 1500,
				});
			});
	};

	/** Retrieves a list of US Sates */
	getUSStates() {
		GenericService.getUSStates()
			.then(({ data }) => {
				this.USStates = data;
			})
			.catch(() => {
				utils.notify({
					type: "error",
					message: "Could not retrieve US State list",
					timeOut: 1500,
				});
			});
	}

	/**
	 * Retrieves a list of counties per state
	 * @param {Number} stateId The unique id of a selected state
	 */
	getCounties = stateId => {
		this.setState({ loadingCounties: true });

		JurisdictionService.getAll({ stateId })
			.then(({ data }) => {
				const counties = data.map((item, index) => ({ value: index, label: item }));
				this.setState({ counties, loadingCounties: false });
			})
			.catch(() => {
				utils.notify({
					type: "error",
					message: "Error loading counties",
					timeOut: 1500,
				});
			});
	};

	/**
	 * Retrieves a list of jurisdictions associated with a state
	 * @param {Number} stateId The unique id of a selected state
	 * @param {String} countyName The name of the county associated with a state
	 */
	getJurisdictions = (stateId, countyName) => {
		this.setState({ loadingJurisdictions: true });
		JurisdictionService.getAll({ stateId, county: countyName })
			.then(({ data }) => {
				const jurisdictions = data.map(({ Id: value, Name: label }) => ({ value, label }));
				this.setState({ jurisdictions, loadingJurisdictions: false });
			})
			.catch(() => {
				utils.notify({
					type: "error",
					message: "Error loading jurisdictions",
					timeOut: 1500,
				});
			});
	};

	/**
	 * Gathers and validates all information required for creating a users LEA level account
	 * @param {Object} form All required data required for a successful accunt creation
	 */
	createLeaSignUp = form => {
		const { activeForm } = this.state;
		const validation = this.validateFormSections(activeForm);

		SignUpService.signUpLEA(form)
			.then(({ data }) => {
				if (data.SignUpToken) {
					utils.notify({
						type: "success",
						message: "Check your E-Mail in order to activate your account",
						title: "Account Successfully Created",
					});
					this.goToStep(validation.nextStep, validation.nextSubStep);
				}

				this.setState(state => ({
					signUpToken: data.SignUpToken,
					buttonState: "success",
					// Set bank account billing info based on data provided at step 0
					bankAccountInfo: {
						...state.bankAccountInfo,
						account_holder_name: `${state.personalInfo.firstName} ${state.personalInfo.lastName}`,
						state: state.departmentInfo.state,
					},
				}));

				localStorage.removeItem("referrer");
			})
			.catch(error => {
				const {
					response: {
						data: { Message },
					},
				} = error;
				utils.notify({
					type: "error",
					message: Message || "Error in creating your account",
					title: "Error",
				});
				this.setState({ buttonState: "error" }, () => {
					setTimeout(() => {
						clearTimeout();
						this.setState({ buttonState: "" });
					}, 1200);
				});
			});
	};

	/**
	 * Saves all changes associated with direct deposit information set up by the LEA which is signing up
	 * @param {Object} userData values specific to the users details
	 * @param {Object} accountData values specific to the users account details
	 */
	saveDirectDepositAccount = async (userData, accountData) => {
		const { lang } = global;
		const { signUpToken, activeForm } = this.state;
		const validation = this.validateFormSections(activeForm);

		let imageToken = { id: null };
		if (accountData.account_holder_type === BANK_ACCOUNT_TYPES.INDIVIDUAL.value) {
			imageToken = await StripeService.createImageToken(userData.photoId);
			if (imageToken.error) {
				this.setState({ buttonState: "error" }, () => {
					setTimeout(() => {
						clearTimeout();
						this.setState({ buttonState: "" });
					}, 1200);
				});
				return utils.notify({
					type: "error",
					message: imageToken.error.message,
				});
			}
		}
		const stateName = this.USStates.find(item => item.Id === parseInt(userData.state, 10)).Name;
		const accountToken = await StripeService.createAccountToken(
			{
				...userData,
				account_holder_type: accountData.account_holder_type,
				state: stateName,
			},
			imageToken.id,
		);
		if (accountToken.error) {
			this.setState({ buttonState: "error" }, () => {
				setTimeout(() => {
					clearTimeout();
					this.setState({ buttonState: "" });
				}, 1200);
			});
			return utils.notify({
				type: "error",
				message: accountToken.error.message,
			});
		}

		const bankAccountToken = await StripeService.createBankAccountToken(accountData);
		if (bankAccountToken.error) {
			this.setState({ buttonState: "error" }, () => {
				setTimeout(() => {
					clearTimeout();
					this.setState({ buttonState: "" });
				}, 1200);
			});
			return utils.notify({
				type: "error",
				message: bankAccountToken.error.message,
			});
		}

		const data = {
			AccountTokenId: accountToken.token.id,
			BankAccount: {
				TokenId: bankAccountToken.token.id,
			},
		};
		SignUpService.saveDirectDepositAccount({ token: signUpToken }, data)
			.then(() => {
				utils.notify({
					type: "success",
					message: "The direct deposit account was successfully registered.",
				});
				this.setState({ buttonState: "success" }, () => {
					this.goToStep(validation.nextStep, validation.nextSubStep);
				});
			})
			.catch(({ response: { data: error } }) => {
				utils.notify({
					type: "error",
					message: error?.Message ?? lang.t("Error saving bank account details"),
				});
				this.setState({ buttonState: "error" }, () => {
					setTimeout(() => {
						clearTimeout();
						this.setState({ buttonState: "" });
					}, 1200);
				});
			});

		return null;
	};

	handleOnChange = (formType, name) => e => {
		const { type, checked } = e.target;
		let { value } = e.target;

		if (type === "checkbox") {
			value = checked;
		}

		if (name === "postal_code") {
			// Replace non digits with empty string
			value = value.replace(/\D/g, "");
		}

		if (name === "state" && formType === "departmentInfo") {
			this.setState(
				prevState => ({
					counties: [],
					jurisdictions: [],
					departmentInfo: {
						...prevState.departmentInfo,
						jurisdictionId: "",
						jurisdictionName: "",
						countyId: "",
						countyName: "",
					},
				}),
				() => this.getCounties(value),
			);
		}

		this.setState(prevState => ({
			[formType]: {
				...prevState[formType],
				[name]: value,
			},
		}));
	};

	handleOnPhotoChange = e => {
		const { files } = e.target;
		if (!files || !files[0]) return;
		const [{ type }] = files;
		this.setState({ validPhotoIdSelected: type.includes("image") }, () => {
			if (type.includes("image")) {
				const photoPreview = URL.createObjectURL(files[0]);
				const photoId = files[0];
				this.setState(prevState => ({
					bankAccountInfo: {
						...prevState.bankAccountInfo,
						photoId,
						photoPreview,
					},
				}));
			}
		});
	};

	handleOnSelectChange = name => e => {
		const {
			departmentInfo: { state },
		} = this.state;
		let value;
		let label;
		if (!e) {
			value = "";
			label = "";
		} else ({ value, label } = e);

		if (name === "county") {
			this.setState(
				prevState => ({
					departmentInfo: {
						...prevState.departmentInfo,
						jurisdictions: [],
						countyId: value,
						countyName: label,
						jurisdictionId: "",
						jurisdictionName: "",
					},
				}),
				() => {
					if (value !== "") {
						const {
							departmentInfo: { countyName },
						} = this.state;
						this.getJurisdictions(state, countyName);
					}
				},
			);
		}

		if (name === "jurisdictionId") {
			this.setState(prevState => ({
				departmentInfo: {
					...prevState.departmentInfo,
					jurisdictionId: value,
					jurisdictionName: label,
				},
			}));
		}
	};

	handleAddFee = feeType => () => {
		const newFee = { JurisdictionFeeType: 1, Rate: "" };
		if (feeType === "generalFees") {
			newFee.Description = "";
		} else if (feeType === "vehicleFees") {
			newFee.VehicleTypeId = "";
		}

		this.setState(prevState => ({
			invoicingInfo: {
				...prevState.jurisdictionFees,
				jurisdictionFees: {
					[feeType]: [...prevState.jurisdictionFees[feeType], newFee],
				},
			},
		}));
	};

	handleChangeFee = (feeType, index, type, property) => e => {
		const {
			invoicingInfo: { jurisdictionFees },
		} = this.state;
		let value = "";
		switch (type) {
			case "text":
				value = e.target.value;
				break;
			case "select":
				value = e ? e.value : "";
				break;
			default:
				break;
		}

		const newFees = jurisdictionFees[feeType].data.map((item, j) => {
			if (j === index) {
				return { ...item, [property]: value };
			}
			return item;
		});
		this.setState(prevState => ({
			jurisdictionFees: {
				...prevState.jurisdictionFees,
				[feeType]: newFees,
			},
		}));
	};

	handleRemoveFee = (feeType, index) => () => {
		this.setState(prevState => ({
			jurisdictionFees: {
				...prevState.jurisdictionFees,
				[feeType]: prevState.jurisdictionFees[feeType].data.filter(
					(item, j) => j !== index,
				),
			},
		}));
	};

	handleVehicleAdd = () => {
		const vehicle = { VehicleTypeId: "", Rate: "", JurisdictionFeeType: 1 };
		this.setState(prevState => ({
			invoicingInfo: {
				...prevState.invoicingInfo,
				jurisdictionFees: {
					...prevState.invoicingInfo.jurisdictionFees,
					vehicleFees: [...prevState.invoicingInfo.jurisdictionFees.vehicleFees, vehicle],
				},
			},
		}));
	};

	toggleVehicleFees = () =>
		this.setState(prevState => ({ showVehicleFees: !prevState.showVehicleFees }));

	handleVehicleFeeChange = (index, property) => e => {
		const {
			target: { value },
		} = e;
		const {
			invoicingInfo: {
				jurisdictionFees: {
					vehicleFees: [...vehicleFees],
				},
			},
		} = this.state;
		// Limit rate input values to 2 decimal places
		const shouldValueChange =
			property !== "Rate" || (property === "Rate" && value.match(/^\d*\.?\d{0,2}$/g));
		vehicleFees[index] = {
			...vehicleFees[index],
			[property]: shouldValueChange ? value : vehicleFees[index][property],
		};

		this.setState(prevState => ({
			invoicingInfo: {
				...prevState.invoicingInfo,
				jurisdictionFees: {
					...prevState.invoicingInfo.jurisdictionFees,
					vehicleFees,
				},
			},
		}));
	};

	handleVehicleDelete = index => {
		this.setState(prevState => ({
			invoicingInfo: {
				...prevState.invoicingInfo,
				jurisdictionFees: {
					...prevState.invoicingInfo.jurisdictionFees,
					vehicleFees: prevState.invoicingInfo.jurisdictionFees.vehicleFees.filter(
						(v, idx) => idx !== index,
					),
				},
			},
		}));
	};

	handleGeneralFeeAdd = () => {
		const newFee = { Description: "", Rate: "", JurisdictionFeeType: 1 };
		this.setState(prevState => ({
			invoicingInfo: {
				...prevState.invoicingInfo,
				jurisdictionFees: {
					...prevState.invoicingInfo.jurisdictionFees,
					generalFees: [...prevState.invoicingInfo.jurisdictionFees.generalFees, newFee],
				},
			},
		}));
	};

	toggleGeneralFees = () =>
		this.setState(prevState => ({ showGeneralFees: !prevState.showGeneralFees }));

	handleGeneralFeeChange = (index, property) => event => {
		const {
			target: { value },
		} = event;
		const {
			invoicingInfo: {
				jurisdictionFees: {
					generalFees: [...generalFees],
				},
			},
		} = this.state;
		// Limit rate input values to 2 decimal places
		const shouldValueChange =
			property !== "Rate" || (property === "Rate" && value.match(/^\d*\.?\d{0,2}$/g));
		generalFees[index] = {
			...generalFees[index],
			[property]: shouldValueChange ? value : generalFees[index][property],
		};

		this.setState(prevState => ({
			invoicingInfo: {
				...prevState.invoicingInfo,
				jurisdictionFees: {
					...prevState.invoicingInfo.jurisdictionFees,
					generalFees,
				},
			},
		}));
	};

	handleGeneralFeeDelete = index => {
		this.setState(prevState => ({
			invoicingInfo: {
				...prevState.invoicingInfo,
				jurisdictionFees: {
					...prevState.invoicingInfo.jurisdictionFees,
					generalFees: prevState.invoicingInfo.jurisdictionFees.generalFees.filter(
						(f, idx) => idx !== index,
					),
				},
			},
		}));
	};

	/**
	 * Validates the required input values per section
	 * @param {String} activeForm The sectoin being validated
	 * @returns {Object} Determines the idf the section is valid
	 */
	validateFormSections = activeForm => {
		const { lang } = global;
		// destructure errors object out of each individual parent state object
		const {
			personalInfo: {
				errors: { ...personalInfoErrors },
				...personalInfo
			},
			departmentInfo: {
				errors: { ...departmentInfoErrors },
				...departmentInfo
			},
			bankAccountInfo: {
				errors: { ...bankAccountInfoErrors },
				...bankAccountInfo
			},
			invoicingInfo: {
				errors: { ...invoicingInfoErrors },
				...invoicingInfo
			},
			agencyRules: {
				errors: { ...agencyRulesErrors },
				...agencyRules
			},
			officerRules: {
				errors: { ...officerRulesErrors },
				...officerRules
			},
			agreeToTerms,
		} = this.state;
		const passwordMatch = personalInfo.password.trim() === personalInfo.confirmPassword.trim();
		const accountNumberMatch =
			bankAccountInfo.account_number.trim() === bankAccountInfo.account_number_confirm.trim();
		// eslint-disable-next-line prefer-regex-literals
		const emailRegex = new RegExp(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/g);
		// eslint-disable-next-line prefer-regex-literals
		const USZipCodeRegex = new RegExp(/^\d{5}$/);
		let isValid = true;
		let nextStep = 1;
		let nextSubStep = 1;
		let generalFeeError = false;
		let vehicleFeeError = false;
		let feeErrorDetail = "";

		// individually validate each form
		switch (activeForm) {
			case "departmentInfo":
				departmentInfoErrors.state = departmentInfo.state === "";
				departmentInfoErrors.countyId = departmentInfo.countyId === "";
				departmentInfoErrors.jurisdictionId = departmentInfo.jurisdictionId === "";
				departmentInfoErrors.agreeToTerms = !agreeToTerms;
				this.setState(prevState => ({
					departmentInfo: { ...prevState.departmentInfo, errors: departmentInfoErrors },
				}));
				// filter out all keys value pairs with existing errors. returns false if errors exist
				isValid =
					Object.values(departmentInfoErrors).filter(error => error === true).length ===
					0;
				nextStep = 2;
				break;

			case "bankAccountInfo":
				bankAccountInfoErrors.id_number =
					bankAccountInfo.account_holder_type === "1" && bankAccountInfo.id_number === "";
				bankAccountInfoErrors.dateOfBirth =
					bankAccountInfo.account_holder_type === "1" &&
					bankAccountInfo.dateOfBirth === "";
				bankAccountInfoErrors.photoId =
					bankAccountInfo.account_holder_type === "1" && bankAccountInfo.photoId === "";
				bankAccountInfoErrors.photoPreview =
					bankAccountInfo.account_holder_type === "1" &&
					bankAccountInfo.photoPreview === "";
				bankAccountInfoErrors.tax_id =
					bankAccountInfo.account_holder_type === "2" && bankAccountInfo.tax_id === "";
				bankAccountInfoErrors.name =
					bankAccountInfo.account_holder_type === "2" && bankAccountInfo.name === "";
				bankAccountInfoErrors.account_holder_name =
					bankAccountInfo.account_holder_name === "";
				bankAccountInfoErrors.routing_number =
					bankAccountInfo.routing_number.trim().length < 9;
				bankAccountInfoErrors.account_number =
					bankAccountInfo.account_number.trim().length < 10;
				bankAccountInfoErrors.account_number_confirm =
					!accountNumberMatch ||
					bankAccountInfo.account_number_confirm.trim().length < 10;
				bankAccountInfoErrors.account_holder_type =
					bankAccountInfo.account_holder_type === "";
				bankAccountInfoErrors.line1 = bankAccountInfo.line1 === "";
				bankAccountInfoErrors.city = bankAccountInfo.city === "";
				bankAccountInfoErrors.state = bankAccountInfo.state === "";
				bankAccountInfoErrors.postal_code = !USZipCodeRegex.test(
					bankAccountInfo.postal_code,
				);
				bankAccountInfoErrors.phone =
					personalInfo.phone === "" || utils.getDigits(personalInfo.phone).length !== 10;
				bankAccountInfoErrors.fullyAuthorized =
					bankAccountInfo.fullyAuthorized === "" ||
					bankAccountInfo.fullyAuthorized === false;
				this.setState(prevState => ({
					bankAccountInfo: {
						...prevState.bankAccountInfo,
						errors: bankAccountInfoErrors,
					},
				}));
				isValid =
					Object.values(bankAccountInfoErrors).filter(error => error === true).length ===
					0;
				nextStep = 2;
				nextSubStep = 2;
				break;

			case "invoicingInfo":
				invoicingInfo.jurisdictionFees.generalFees.forEach(fee => {
					const type = parseInt(fee.JurisdictionFeeType, 10);
					const rate = parseFloat(fee.Rate);

					if (fee.Description.trim() === "") {
						generalFeeError = true;
						feeErrorDetail += "Non-vehicle fees must have an associated description. ";
					}

					if (Number.isNaN(rate)) {
						generalFeeError = true;
						feeErrorDetail += "Please specify a rate for the general fee";
					}

					if (!generalFeeError && type === 3) {
						// Percentage-based fees must be within the range of 0-100
						if (rate <= 0 || rate > 100) {
							generalFeeError = true;
							feeErrorDetail += "Percentage based fees must be between 0 and 100. ";
						}
					} else if (!generalFeeError && rate <= 0) {
						generalFeeError = true;
						feeErrorDetail += "Per job and per hour rates cannot be less than 0. ";
					}
				});

				invoicingInfo.jurisdictionFees.vehicleFees.forEach(fee => {
					const type = parseInt(fee.JurisdictionFeeType, 10);
					const vehicleType = parseInt(fee.VehicleTypeId, 10);
					const rate = parseFloat(fee.Rate);

					if (Number.isNaN(rate)) {
						vehicleFeeError = true;
						feeErrorDetail += "Please specify a rate for the vehicle. ";
					}

					if (fee.JurisdictionFeeType && Number.isNaN(vehicleType)) {
						vehicleFeeError = true;
						feeErrorDetail += "Please select a vehicle type. ";
					}

					if (!vehicleFeeError && type === 3) {
						// Percentage-based fees must be within the range of 0-100
						if (rate <= 0 || rate > 100) {
							vehicleFeeError = true;
							feeErrorDetail += "Percentage based fees must be between 0 and 100. ";
						}
					} else if (!vehicleFeeError && rate <= 0) {
						vehicleFeeError = true;
						feeErrorDetail += "Per job and per hour rates cannot be less than 0. ";
					}
				});

				if ((generalFeeError || vehicleFeeError) && feeErrorDetail) {
					utils.notify({
						type: "error",
						message: feeErrorDetail,
					});
				}

				invoicingInfoErrors.generalFees =
					invoicingInfo.jurisdictionFees.generalFees.length !== 0 && generalFeeError;
				invoicingInfoErrors.vehicleFees =
					invoicingInfo.jurisdictionFees.vehicleFees.length !== 0 && vehicleFeeError;

				this.setState(prevState => ({
					invoicingInfo: { ...prevState.invoicingInfo, errors: invoicingInfoErrors },
				}));
				isValid =
					Object.values(invoicingInfoErrors).filter(error => error === true).length === 0;
				nextStep = 3;
				break;

			case "agencyRules":
				if (
					agencyRules.IsJobLocationTypeRestricted &&
					agencyRules.RestrictedJobLocationTypes.length === 0
				) {
					agencyRulesErrors.RestrictedJobLocationTypes = true;
					utils.notify({
						type: "error",
						message: "Must select a restricted location",
					});
				} else {
					agencyRulesErrors.RestrictedJobLocationTypes = false;
				}
				this.setState(prevState => ({
					agencyRules: { ...prevState.agencyRules, errors: agencyRulesErrors },
				}));
				isValid =
					Object.values(agencyRulesErrors).filter(error => error === true).length === 0;
				nextStep = 3;
				nextSubStep = 2;
				break;

			case "officerRules":
				if (
					officerRules.JobAutoAssignType === "3" ||
					officerRules.JobAutoAssignType === "4"
				) {
					officerRulesErrors.JobAutoAssignHoursSpan =
						officerRules.JobAutoAssignHoursSpan === "";
					if (officerRules.JobAutoAssignYearToDateSpan === true) {
						officerRulesErrors.JobAutoAssignJobCountDaysSpan =
							officerRules.JobAutoAssignJobCountDaysSpan === "";
					} else {
						officerRulesErrors.JobAutoAssignJobCountDaysSpan = false;
					}
				} else if (
					officerRules.JobAutoAssignType === "5" ||
					officerRules.JobAutoAssignType === "6"
				) {
					officerRulesErrors.JobAutoAssignHoursSpan =
						officerRules.JobAutoAssignHoursSpan === "";
				} else if (officerRules.JobAutoAssignType === "7") {
					officerRulesErrors.JobAutoAssignHoursSpan =
						officerRules.JobAutoAssignHoursSpan === "";
				} else {
					officerRulesErrors.JobAutoAssignHoursSpan = false;
					officerRulesErrors.JobAutoAssignYearToDateSpan = false;
					officerRulesErrors.JobAutoAssignJobCountDaysSpan = false;
					officerRulesErrors.signUpPeriodHoursMultiplier = false;
				}
				if (
					officerRules.JobRestrictionType === 20 &&
					officerRules.JobLocationRestrictedCities.length === 0 &&
					officerRules.JobLocationRestrictedCounties.length === 0
				) {
					officerRulesErrors.JobRestrictionType = true;
				} else {
					officerRulesErrors.JobRestrictionType = false;
				}
				this.setState(prevState => ({
					officerRules: { ...prevState.officerRules, errors: officerRulesErrors },
				}));
				isValid =
					Object.values(officerRulesErrors).filter(error => error === true).length === 0;
				nextStep = 4;
				break;

			case "personalInfo":
			default:
				personalInfoErrors.firstName = personalInfo.firstName === "";
				personalInfoErrors.lastName = personalInfo.lastName === "";
				personalInfoErrors.email = !emailRegex.test(personalInfo.email);
				personalInfoErrors.phone =
					personalInfo.phone === "" || utils.getDigits(personalInfo.phone).length !== 10;
				personalInfoErrors.password = personalInfo.password.trim().length < 6;
				personalInfoErrors.confirmPassword =
					!passwordMatch || personalInfo.confirmPassword.trim().length < 6;
				personalInfoErrors.title = personalInfo.title === "";
				this.setState(prevState => ({
					personalInfo: { ...prevState.personalInfo, errors: personalInfoErrors },
				}));
				if (personalInfo.password.trim().length < 6) {
					utils.notify({
						type: "error",
						message: lang.t("Password must be stronger"),
					});
				}
				if (personalInfo.password !== personalInfo.confirmPassword) {
					utils.notify({
						type: "error",
						message: lang.t("Passwords do not match"),
					});
				}
				isValid =
					Object.values(personalInfoErrors).filter(error => error === true).length === 0;
				break;
		}

		return { isValid, nextStep, nextSubStep };
	};

	handleCheckboxChange = (formType, name, value) => {
		// clear conditional input values when toggling checkbox/radio inputs
		if (
			formType === "agencyRules" &&
			name === "IsJobLocationTypeRestricted" &&
			value === false
		) {
			this.setState(prevState => ({
				agencyRules: {
					...prevState.agencyRules,
					RestrictedJobLocationTypes: [],
				},
			}));
		}

		if (formType === "officerRules") {
			if (name === "limitedHours" && value === false) {
				this.setState(prevState => ({
					officerRules: {
						...prevState.officerRules,
						MaxWeeklyHours: "",
						MaxWeeklyHoursType: "",
					},
				}));
			}
			if (name === "JobAutoAssignType" && (value === "1" || value === "2")) {
				this.setState(prevState => ({
					officerRules: {
						...prevState.officerRules,
						JobAutoAssignHoursSpan: "",
						signUpPeriodHoursMultiplier: "",
						JobAutoAssignJobCountDaysSpan: "",
						JobAutoAssignYearToDateSpan: "",
					},
				}));
			}
			if (name === "JobCallOffType" && value !== "2") {
				this.setState(prevState => ({
					officerRules: {
						...prevState.officerRules,
						JobCallOffReplacementTypes: [],
					},
				}));
			}
		}

		this.setState(prevState => ({
			[formType]: {
				...prevState[formType],
				[name]: value,
			},
		}));
	};

	/**
	 * Handles all changes made specific to call off replacement types
	 * @param {Event} e HTML event to inspect for handling updates to call off replacement type changes
	 */
	handleReplacementTypeChange = e => {
		const {
			target: { value },
		} = e;
		this.setState(prevState => {
			const prevReplacementTypes = prevState.officerRules.JobCallOffReplacementTypes;
			if (prevReplacementTypes.includes(parseInt(value, 10))) {
				return {
					officerRules: {
						...prevState.officerRules,
						JobCallOffReplacementTypes: prevReplacementTypes.filter(
							type => type !== parseInt(value, 10),
						),
					},
				};
			}
			return {
				officerRules: {
					...prevState.officerRules,
					JobCallOffReplacementTypes: [...prevReplacementTypes, parseInt(value, 10)],
				},
			};
		});
	};

	handleLocationTypeChange = id => e => {
		const { checked } = e.target;
		if (checked) {
			this.setState(prevState => ({
				agencyRules: {
					...prevState.agencyRules,
					RestrictedJobLocationTypes: [
						...prevState.agencyRules.RestrictedJobLocationTypes,
						id,
					],
				},
			}));
		} else {
			this.setState(prevState => ({
				agencyRules: {
					...prevState.agencyRules,
					RestrictedJobLocationTypes: [
						...prevState.agencyRules.RestrictedJobLocationTypes.filter(
							item => item !== id,
						),
					],
				},
			}));
		}
	};

	/** Handles and validates all changes made to the personal information section */
	handlePersonalInfo = () => {
		const { activeForm } = this.state;
		const validation = this.validateFormSections(activeForm);
		if (validation.isValid) {
			this.setState({ buttonState: "success" }, () => {
				this.goToStep(validation.nextStep, validation.nextSubStep);
			});
		} else {
			this.setState({ buttonState: "error" }, () => {
				setTimeout(() => {
					clearTimeout();
					this.setState({ buttonState: "" });
				}, 1200);
			});
		}
	};

	/** Handles and validates all changes made to the department information section */
	handleDepartmentInfo = () => {
		const { activeForm, personalInfo, departmentInfo, agreeToTerms } = this.state;
		const validation = this.validateFormSections(activeForm);
		const data = {
			FirstName: personalInfo.firstName,
			LastName: personalInfo.lastName,
			Email: personalInfo.email,
			MobilePhone: utils.getDigits(personalInfo.phone),
			Password: personalInfo.password,
			ConfirmPassword: personalInfo.confirmPassword,
			Title: personalInfo.title,
			JurisdictionId: departmentInfo.jurisdictionId,
			Salesperson: localStorage.getItem("referrer") || "",
		};
		if (validation.isValid && agreeToTerms) {
			this.createLeaSignUp(data);
		} else {
			this.setState({ buttonState: "error" }, () => {
				setTimeout(() => {
					clearTimeout();
					this.setState({ buttonState: "" });
				}, 1200);
			});
		}
	};

	/** Handles and validates all changes made to the bank account information section */
	handleBankAccountInfo = () => {
		const { activeForm, bankAccountInfo, personalInfo } = this.state;
		const validation = this.validateFormSections(activeForm);
		const accountData = {
			account_holder_name: bankAccountInfo.account_holder_name,
			account_number: bankAccountInfo.account_number,
			account_holder_type: parseInt(bankAccountInfo.account_holder_type, 10),
			account_number_confirm: bankAccountInfo.account_number_confirm,
			routing_number: bankAccountInfo.routing_number,
		};
		const userData = {
			state: bankAccountInfo.state,
			city: bankAccountInfo.city,
			line1: bankAccountInfo.line1,
			postal_code: bankAccountInfo.postal_code,
			phoneNumber: utils.getDigits(personalInfo.phone),
		};

		if (accountData.account_holder_type === BANK_ACCOUNT_TYPES.INDIVIDUAL.value) {
			userData.id_number = bankAccountInfo.id_number;
			userData.first_name = personalInfo.firstName;
			userData.last_name = personalInfo.lastName;
			userData.dateOfBirth = bankAccountInfo.dateOfBirth;
			userData.email = personalInfo.email;
			userData.photoId = bankAccountInfo.photoId;
		} else if (accountData.account_holder_type === BANK_ACCOUNT_TYPES.COMPANY.value) {
			userData.tax_id = bankAccountInfo.tax_id;
			userData.name = bankAccountInfo.name;
		}

		if (validation.isValid) {
			this.saveDirectDepositAccount(userData, accountData);
		} else {
			this.setState({ buttonState: "error" }, () => {
				setTimeout(() => {
					clearTimeout();
					this.setState({ buttonState: "" });
				}, 1200);
			});
		}
	};

	/** Handles and validates all changes made to the invoice information section */
	handleInvoiceInfo = () => {
		const {
			activeForm,
			invoicingInfo: {
				jurisdictionFees,
				IsOfficerInvoiceApprovalRequired,
				TransferPaymentToJurisdiction,
				TransferCoordinatorPaymentToJurisdiction,
				OfficerInsuranceOptIn,
			},
		} = this.state;
		const validation = this.validateFormSections(activeForm);
		if (validation.isValid) {
			this.saveJurisdictionFees({
				IsOfficerInvoiceApprovalRequired,
				TransferPaymentToJurisdiction,
				TransferCoordinatorPaymentToJurisdiction,
				OfficerInsuranceOptIn,
				JurisdictionFees: jurisdictionFees.generalFees,
				JurisdictionVehicleFees: jurisdictionFees.vehicleFees,
			});
		} else {
			this.setState({ buttonState: "error" }, () => {
				setTimeout(() => {
					clearTimeout();
					this.setState({ buttonState: "" });
				}, 1200);
			});
		}
	};

	/** Handles and validates all changes made to the agency rules section */
	handleAgencyRules = () => {
		const {
			activeForm,
			agencyRules: {
				IsJobLocationTypeRestricted,
				RestrictedJobLocationTypes,
				IsJobLocationApprovalRequired,
			},
		} = this.state;
		const validation = this.validateFormSections(activeForm);
		const data = {
			IsJobLocationTypeRestricted,
			RestrictedJobLocationTypes,
			IsJobLocationApprovalRequired,
		};
		if (validation.isValid) {
			this.saveAgencyRules(data);
		} else {
			this.setState({ buttonState: "error" }, () => {
				setTimeout(() => {
					clearTimeout();
					this.setState({ buttonState: "" });
				}, 1200);
			});
		}
	};

	/** Handles and validates all changes made to the officer rules section */
	handleOfficerRules = () => {
		const {
			activeForm,
			officerRules: {
				JobAutoAssignHoursSpan,
				JobAutoAssignYearToDateSpan,
				JobCallOffExpirationMinutes,
				ExtraDutyApprovalRequired,
				JobAutoAssignJobCountDaysSpan,
				JobAutoAssignType,
				JobCallOffType,
				JobCallOffReplacementTypes,
				JobLocationRestrictedCities,
				JobLocationRestrictedCounties,
				JobRestrictionType,
				MaxWeeklyHours,
				MaxWeeklyHoursType,
				signUpPeriodHoursMultiplier,
			},
		} = this.state;
		const validation = this.validateFormSections(activeForm);
		const data = {
			JobAutoAssignHoursSpan:
				parseInt(JobAutoAssignHoursSpan, 10) * parseInt(signUpPeriodHoursMultiplier, 10),
			JobAutoAssignYearToDateSpan,
			JobCallOffExpirationMinutes,
			ExtraDutyApprovalRequired,
			JobAutoAssignJobCountDaysSpan,
			JobAutoAssignType,
			JobCallOffType,
			JobCallOffReplacementTypes,
			JobLocationRestrictedCities,
			JobLocationRestrictedCounties,
			JobRestrictionType,
			MaxWeeklyHours,
			MaxWeeklyHoursType,
		};
		if (validation.isValid) {
			this.saveOfficerRules(data);
		} else {
			this.setState({ buttonState: "error" }, () => {
				setTimeout(() => {
					clearTimeout();
					this.setState({ buttonState: "" });
				}, 1200);
			});
		}
	};

	/**
	 * Toggles which section needs to be displayed and validated
	 * @param {Number} step The main step of the sign up process
	 * @param {Number} subStep The substep of a given sectoin in the sign up process
	 */
	goToStep = (step, subStep) => {
		// updates to the current step/subStep and sets the active form for validation
		switch (step) {
			case 1:
				this.setState({ activeForm: "departmentInfo" });
				break;
			case 2:
				if (subStep === 2) {
					this.setState({ activeForm: "invoicingInfo" });
				} else {
					this.setState({ activeForm: "bankAccountInfo" });
				}
				break;
			case 3:
				if (subStep === 2) {
					this.setState({ activeForm: "officerRules" });
				} else {
					this.setState({ activeForm: "agencyRules" });
				}
				break;
			default:
				this.setState({ activeForm: "personainfo" });
				break;
		}
		this.setState({ step, subStep, buttonState: "" });
	};

	skipStep = nextStep => {
		if (nextStep === 1) {
			this.goToStep(0, 1);
		} else {
			this.goToStep(nextStep + 1);
			this.setState({ subStep: 1 });
		}
	};

	/**
	 * A callback method used to create a new depratment which will be made available in the jurisdiction list
	 * @param {Object} data THe object being passed bakc from the Create Jurisdiction modal
	 */
	setNewDepartment = data => {
		const { lang } = global;
		utils.notify({
			type: "warning",
			message: lang.t(
				"The Department has been created, but it still needs to be approved by an administrator",
			),
		});
		const { Id: stateId } = this.USStates.find(item => item.Name === data.StateName);
		JurisdictionService.getAll({ stateId })
			.then(({ data: countyData }) => {
				const counties = countyData.map((item, index) => ({ value: index, label: item }));
				const county = counties.find(
					item => item.label.toLowerCase() === data.County.toLowerCase(),
				) || { label: "", value: "" };
				const jurisdictions = [{ value: data.Id, label: data.Name }];
				this.setState(prevState => ({
					counties,
					jurisdictions,
					departmentInfo: {
						...prevState.departmentInfo,
						state: stateId,
						countyId: county.value,
						countyName: county.label,
						jurisdictionId: data.Id,
						jurisdictionName: data.Name,
					},
				}));
			})
			.catch(() => {
				this.setState({ buttonState: "error" }, () => {
					setTimeout(() => {
						clearTimeout();
						this.setState({ buttonState: "" });
					}, 1200);
				});
			});
	};

	/**
	 * Gathers and saves all information related to jurisdiction fees
	 * @param {Object} form The jurisdiction fee values being saved
	 */
	saveJurisdictionFees = form => {
		const { signUpToken, activeForm } = this.state;
		const validation = this.validateFormSections(activeForm);
		this.setState({ buttonState: "loading" });

		SignUpService.saveJurisdictionFees({ token: signUpToken }, form)
			.then(() => {
				utils.notify({
					type: "success",
					message: "The fees have been successfully saved",
				});
				this.setState({ buttonState: "success" }, () => {
					this.goToStep(validation.nextStep, validation.nextSubStep);
				});
			})
			.catch(error => {
				utils.notify({
					type: "error",
					message: error.message,
				});
				this.setState({ buttonState: "error" }, () => {
					setTimeout(() => {
						clearTimeout();
						this.setState({ buttonState: "" });
					}, 1200);
				});
			});
	};

	/**
	 * Gathers and saves all information related to agency rules
	 * @param {Object} form The agency rule values being saved
	 */
	saveAgencyRules = form => {
		const { signUpToken, activeForm } = this.state;
		const validation = this.validateFormSections(activeForm);
		this.setState({ buttonState: "loading" });

		SignUpService.saveAgencyRules({ token: signUpToken }, form)
			.then(() => {
				utils.notify({
					type: "success",
					message: "The agency rules have been successfully saved",
				});
				this.setState({ buttonState: "success" }, () => {
					this.goToStep(validation.nextStep, validation.nextSubStep);
				});
			})
			.catch(error => {
				utils.notify({
					type: "error",
					message: error.message,
				});
				this.setState({ buttonState: "error" }, () => {
					setTimeout(() => {
						clearTimeout();
						this.setState({ buttonState: "" });
					}, 1200);
				});
			});
	};

	/**
	 * Gathers and saves all information related to officer rules
	 * @param {Object} form The officer rule values being saved
	 */
	saveOfficerRules = form => {
		const { signUpToken, activeForm } = this.state;
		const validation = this.validateFormSections(activeForm);
		this.setState({ buttonState: "loading" });

		SignUpService.saveOfficerRules({ token: signUpToken }, form)
			.then(() => {
				utils.notify({
					type: "success",
					message: "The officer rules have been successfully saved",
				});
				this.setState({ buttonState: "success" }, () => {
					this.goToStep(validation.nextStep, validation.nextSubStep);
				});
			})
			.catch(error => {
				utils.notify({
					type: "error",
					message: error.message,
				});
				this.setState({ buttonState: "error" }, () => {
					setTimeout(() => {
						clearTimeout();
						this.setState({ buttonState: "" });
					}, 1200);
				});
			});
	};

	/**
	 * Handles the searching of existing locations retrevied from the service call
	 * @param {String} name The name of the location being queried
	 * @param {Function} callback A callback method used for any subsequent functionality such as updating the jurisdiction list
	 */
	searchLocations = (name, callback) => {
		if (name.length < 3) {
			callback([]);
			return;
		}
		const {
			officerRules: { JobLocationRestrictedCities, JobLocationRestrictedCounties },
			departmentInfo: { state: stateId },
		} = this.state;
		const { lang } = global;
		const state = this.USStates.find(item => item.Id === parseInt(stateId, 10)).Abbreviation;
		RegionSearchService.searchPlaces({ state, name }, c => {
			this.locationCancelToken = c;
		})
			.then(({ data }) => {
				this.locationCancelToken = undefined;
				const mappedData = data.map(({ name: value, type }) => ({
					label: value,
					value,
					type,
				}));
				const existingLocations = [
					...JobLocationRestrictedCities,
					...JobLocationRestrictedCounties,
				];
				// Only returning values that are not already selected to avoid duplication by the user
				callback(mappedData.filter(({ label }) => !existingLocations.includes(label)));
			})
			.catch(err => {
				if (!axios.isCancel(err)) {
					utils.notify({
						type: "error",
						message: lang.t("Error getting locations"),
					});
					callback([]);
				}
			});
	};

	handleJobRestrictionTypeChange = value => () => {
		this.setState(prevState => ({
			officerRules: {
				...prevState.officerRules,
				JobRestrictionType: value,
			},
		}));
	};

	handleLocationAdd = () => {
		const { allowedLocations: oldLocations } = this.state;
		const allowedLocations = [
			{ type: undefined, value: undefined, label: "" },
			...oldLocations,
		];
		this.setState({ allowedLocations });
	};

	/**
	 * Adds or removes the selected location from the allowed locations list
	 * @param {*} index The index of the locatoin being edited
	 * @param {*} remove Determines if the location will be removed from the list
	 * @returns {Object} Contains the values associated with the allowed locations and location restrictions
	 */
	handleLocationUpdate =
		(index, remove = false) =>
		event => {
			const { lang } = global;
			const { allowedLocations } = this.state;
			let isCity;
			// If deleting a location that has not yet been added, simply remove it from allowedLocations
			if (remove && !allowedLocations[index].value) {
				this.setState(prevState => ({
					allowedLocations: prevState.allowedLocations.filter(
						(loc, idx) => idx !== index,
					),
				}));
				// If deleting an existing location, remove from allowedLocations and from the appropriate city/county array
			} else if (remove) {
				isCity = allowedLocations[index].type.toLowerCase() === "city";
				this.setState(prevState => {
					const prevCities = prevState.officerRules.JobLocationRestrictedCities;
					const prevCounties = prevState.officerRules.JobLocationRestrictedCounties;
					const JobLocationRestrictedCities = isCity
						? prevCities.filter(
								location =>
									location &&
									typeof location === "string" &&
									location !== allowedLocations[index].label,
							)
						: prevCities;
					const JobLocationRestrictedCounties = isCity
						? prevCounties
						: prevCounties.filter(
								location =>
									location &&
									typeof location === "string" &&
									location !== allowedLocations[index].label,
							);
					return {
						allowedLocations: prevState.allowedLocations.filter(
							(loc, idx) => idx !== index,
						),
						officerRules: {
							...prevState.officerRules,
							JobLocationRestrictedCities,
							JobLocationRestrictedCounties,
						},
					};
				});
				// Otherwise, just add the new city to allowedLocations and the appropriate city/county array
			} else {
				const { label, value, type } = event;
				isCity = type.toLowerCase() === "city";
				allowedLocations[index] = {
					label,
					value,
					type: lang.t(isCity ? "City" : "County"),
				};
				this.setState(prevState => {
					const prevCities = prevState.officerRules.JobLocationRestrictedCities;
					const prevCounties = prevState.officerRules.JobLocationRestrictedCounties;
					const JobLocationRestrictedCities = isCity
						? [...prevCities, allowedLocations[index].label].filter(
								location => location && typeof location === "string",
							)
						: prevCities;
					const JobLocationRestrictedCounties = isCity
						? prevCounties
						: [...prevCounties, allowedLocations[index].label].filter(
								location => location && typeof location === "string",
							);
					return {
						allowedLocations,
						officerRules: {
							...prevState.officerRules,
							JobLocationRestrictedCities,
							JobLocationRestrictedCounties,
						},
					};
				});
			}
		};

	toggleAllowedLocations = () =>
		this.setState(prevState => ({ showAllowedLocations: !prevState.showAllowedLocations }));

	closeJurisdictionModal = () => this.setState({ showJurisdictionModal: false });

	render() {
		const {
			step,
			subStep,
			vehicleTypes,
			locationTypes,
			counties,
			loadingCounties,
			jurisdictions,
			loadingJurisdictions,
			showGeneralFees,
			showVehicleFees,
			showAllowedLocations,
			allowedLocations,
			validPhotoIdSelected,
			agreeToTerms,
			personalInfo,
			buttonState,
			departmentInfo,
			bankAccountInfo,
			invoicingInfo,
			agencyRules,
			officerRules,
			showJurisdictionModal,
		} = this.state;
		const { lang } = global;

		return (
			<div id="signup-lea">
				<nav className="navbar navbar-default navbar-static-top">
					<div className="container-fluid">
						<div className="row">
							<div className="col-xs-4 navbar-header">
								<div className="navbar-brand">
									<img
										src={IconLogo}
										className="visible-xs brand-img"
										alt="Brand"
									/>
									<img
										src={TextLogo}
										className="hidden-xs brand-img"
										alt="Brand"
									/>
									<span className="persona">{lang.t("LEA")}</span>
								</div>
							</div>
							<div className="col-xs-8 sign-in">
								<span>{lang.t("Already a member_")}</span>
								<Link
									className="btn btn-default"
									to="/login"
								>
									{lang.t("Sign In")}
								</Link>
							</div>
						</div>
					</div>
				</nav>
				<div className="progress">
					<div
						role="progressbar"
						className={`progress-bar step${step}`}
						aria-valuenow={((step / 4) * 100).toFixed(2)}
						aria-valuemin="0"
						aria-valuemax="100"
					>
						<span className="sr-only">{`${((step / 4) * 100).toFixed(2)}% Complete`}</span>
					</div>
				</div>

				<div className="container-fluid signup-content">
					<div className="row">
						<div
							className={`signup-form col-md-offset-2 ${
								step === 4 || step === 3 || subStep === 2
									? "col-md-8"
									: "col-sm-6 col-md-5 col-sm-offset-1"
							}`}
						>
							<div className={`signup-form-header ${step === 4 ? "hidden" : "row"}`}>
								<Choose>
									<When condition={step === 2}>
										<h2 className="heading-text">
											{lang.t("Payment and Invoicing")}
										</h2>
									</When>
									<When condition={step === 3 && subStep === 1}>
										<h2 className="heading-text">{lang.t("Agency Rules")}</h2>
									</When>
									<When condition={step === 3 && subStep === 2}>
										<h2 className="heading-text">{lang.t("Officer Rules")}</h2>
									</When>
									<Otherwise>
										<h2>
											<span className="lea-text">{lang.t("LEA")}</span>
											&nbsp;
											<span className="heading-text">
												{lang.t("Sign Up")}
											</span>
										</h2>
									</Otherwise>
								</Choose>
								<h4 className="text-muted">
									{lang.t("We will get you setup in a few steps")}
								</h4>
							</div>

							<div className={`row ${step === 4 ? "hidden" : "signup-form-body"}`}>
								<Choose>
									<When condition={step === 0}>
										<div className="col-xs-12">
											<strong className="signup-form-text">
												{lang.t("Enter your personal information")}
											</strong>
										</div>

										<div
											className={classNames("col-xs-12 col-sm-6 form-group", {
												"has-error": personalInfo.errors.firstName,
											})}
										>
											<label htmlFor="firstName">
												{lang.t("First Name")}
											</label>
											<input
												type="text"
												name="firstName"
												id="firstName"
												className="form-control"
												value={personalInfo.firstName}
												onChange={this.handleOnChange(
													"personalInfo",
													"firstName",
												)}
											/>
										</div>

										<div
											className={classNames("col-xs-12 col-sm-6 form-group", {
												"has-error": personalInfo.errors.lastName,
											})}
										>
											<label htmlFor="lastName">{lang.t("Last Name")}</label>
											<input
												type="text"
												name="lastName"
												id="lastName"
												className="form-control"
												value={personalInfo.lastName}
												onChange={this.handleOnChange(
													"personalInfo",
													"lastName",
												)}
											/>
										</div>

										<div
											className={classNames("col-xs-12 col-sm-6 form-group", {
												"has-error": personalInfo.errors.email,
											})}
										>
											<label htmlFor="email">{lang.t("EMail")}</label>
											<input
												type="email"
												name="email"
												id="email"
												className="form-control"
												value={personalInfo.email}
												onChange={this.handleOnChange(
													"personalInfo",
													"email",
												)}
												data-test-id="login-email-input"
											/>
										</div>

										<div
											className={classNames("col-xs-12 col-sm-6 form-group", {
												"has-error": personalInfo.errors.phone,
											})}
										>
											<label htmlFor="phone">{lang.t("Phone")}</label>
											<MaskedInput
												type="tel"
												name="phone"
												id="phone"
												className="form-control"
												value={personalInfo.phone}
												mask={MASK_VALUE.phoneMask}
												onChange={this.handleOnChange(
													"personalInfo",
													"phone",
												)}
											/>
										</div>

										<div
											className={classNames("col-xs-12 form-group", {
												"has-error": personalInfo.errors.password,
											})}
										>
											<label htmlFor="password">{lang.t("Password")}</label>
											<input
												type="password"
												name="password"
												id="password"
												className="form-control"
												value={personalInfo.password}
												onChange={this.handleOnChange(
													"personalInfo",
													"password",
												)}
											/>
										</div>

										<div
											className={classNames("col-xs-12 form-group", {
												"has-error": personalInfo.errors.confirmPassword,
											})}
										>
											<label htmlFor="confirmPassword">
												{lang.t("Confirm Password")}
											</label>
											<input
												type="password"
												name="confirmPassword"
												className="form-control"
												value={personalInfo.confirmPassword}
												onChange={this.handleOnChange(
													"personalInfo",
													"confirmPassword",
												)}
											/>
										</div>

										<div
											className={classNames("col-xs-12 form-group", {
												"has-error": personalInfo.errors.title,
											})}
										>
											<label htmlFor="title">{lang.t("Title")}</label>
											<input
												type="text"
												name="title"
												id="title"
												className="form-control"
												value={personalInfo.title}
												onChange={this.handleOnChange(
													"personalInfo",
													"title",
												)}
											/>
										</div>
									</When>

									<When condition={step === 1}>
										<strong className="col-xs-12 signup-form-text">
											{lang.t("Department Info")}
										</strong>

										<div
											className={classNames("col-xs-12 col-sm-6 form-group", {
												"has-error": departmentInfo.errors.state,
											})}
										>
											<label htmlFor="state">{lang.t("State")}</label>
											<StateSelection
												ref={this.departmentStateSelection}
												name="state"
												id="state"
												value={departmentInfo.state}
												onChange={this.handleOnChange(
													"departmentInfo",
													"state",
												)}
											/>
										</div>

										<div
											className={classNames("col-xs-12 col-sm-6 form-group", {
												"has-error": departmentInfo.errors.countyId,
											})}
										>
											<label htmlFor="county">{lang.t("County")}</label>
											<ReactSelect
												name="county"
												id="county"
												value={departmentInfo.countyId}
												placeholder={lang.t("Select")}
												options={counties}
												onChange={this.handleOnSelectChange("county")}
												isLoading={loadingCounties}
												isClearable
											/>
										</div>
										<div
											className={classNames("col-xs-12 form-group", {
												"has-error": departmentInfo.errors.jurisdictionId,
											})}
										>
											<label htmlFor="jurisdictionId">
												{lang.t("Department")}
											</label>
											<ReactSelect
												name="jurisdictionId"
												id="jurisdictionId"
												placeholder={lang.t("Select")}
												value={departmentInfo.jurisdictionId}
												options={jurisdictions}
												onChange={this.handleOnSelectChange(
													"jurisdictionId",
												)}
												isLoading={loadingJurisdictions}
												isClearable
											/>
										</div>
										<div className="col-xs-12">
											<button
												type="button"
												className="btn btn-link btn-block"
												onClick={() =>
													this.setState({ showJurisdictionModal: true })
												}
											>
												{`${lang.t("Don_t see your department_")}
												   ${lang.t("Add it now_")}`}
											</button>
										</div>
										<div className="col-xs-12 checkbox text-center">
											<label htmlFor="agreeToTerms">
												<input
													type="checkbox"
													id="agreeToTerms"
													onChange={() =>
														this.setState(prevState => ({
															agreeToTerms: !prevState.agreeToTerms,
														}))
													}
													checked={agreeToTerms}
												/>
												{`${lang.t("I agree to the")} RollKall `}
												<a
													href="https://www.rollkall.com/terms-agencies"
													target="_blank"
													rel="noopener noreferrer"
												>
													{lang.t("Terms of Service")}
												</a>
											</label>
											<If condition={departmentInfo.errors.agreeToTerms}>
												<br />
												<small className="text-danger">
													{lang.t("You must agree to terms of service")}
												</small>
											</If>
										</div>
									</When>
									<When condition={step === 2 && subStep === 1}>
										<strong className="col-xs-12 signup-form-text">
											{lang.t("Bank Account Info")}
										</strong>

										<div
											className={classNames("col-xs-12 form-group", {
												"has-error":
													bankAccountInfo.errors.account_holder_name,
											})}
										>
											<label htmlFor="account_holder_name">
												{lang.t("Account Holder")}
											</label>
											<input
												type="text"
												name="account_holder_name"
												id="account_holder_name"
												className="form-control"
												value={bankAccountInfo.account_holder_name}
												onChange={this.handleOnChange(
													"bankAccountInfo",
													"account_holder_name",
												)}
											/>
										</div>
										<div
											className={classNames("col-xs-12 form-group", {
												"has-error": bankAccountInfo.errors.routing_number,
											})}
										>
											<label htmlFor="routing_number">
												{lang.t("Routing Number")}
											</label>
											<input
												type="tel"
												name="routing_number"
												id="routing_number"
												className="form-control"
												maxLength={9}
												value={bankAccountInfo.routing_number}
												onChange={this.handleOnChange(
													"bankAccountInfo",
													"routing_number",
												)}
											/>
										</div>
										<div
											className={classNames("col-xs-12 col-sm-6 form-group", {
												"has-error": bankAccountInfo.errors.account_number,
											})}
										>
											<label htmlFor="account_number">
												{lang.t("Account Number")}
											</label>
											<input
												type="tel"
												name="account_number"
												id="account_number"
												className="form-control"
												value={bankAccountInfo.account_number}
												onChange={this.handleOnChange(
													"bankAccountInfo",
													"account_number",
												)}
											/>
										</div>
										<div
											className={classNames("col-xs-12 col-sm-6 form-group", {
												"has-error":
													bankAccountInfo.errors.account_number_confirm,
											})}
										>
											<label htmlFor="account_number_confirm">
												{lang.t("Confirm Account Number")}
											</label>
											<input
												type="tel"
												name="account_number_confirm"
												id="account_number_confirm"
												className="form-control"
												value={bankAccountInfo.account_number_confirm}
												onChange={this.handleOnChange(
													"bankAccountInfo",
													"account_number_confirm",
												)}
											/>
										</div>
										<div
											className={classNames("col-xs-12 form-group", {
												"has-error":
													bankAccountInfo.errors.account_holder_type,
											})}
										>
											<label htmlFor="account_holder_type">
												{lang.t("Account Type")}
											</label>
											<select
												type="select"
												name="account_holder_type"
												id="account_holder_type"
												className="form-control"
												value={bankAccountInfo.account_holder_type}
												onChange={this.handleOnChange(
													"bankAccountInfo",
													"account_holder_type",
												)}
											>
												<For
													each="item"
													of={Object.entries(BANK_ACCOUNT_TYPES)}
													index="index"
												>
													<option
														key={`account-type_${item[1].value}`}
														value={item[1].value}
													>
														{item[1].label}
													</option>
												</For>
											</select>
										</div>
										<Choose>
											<When
												condition={
													bankAccountInfo.account_holder_type ===
													BANK_ACCOUNT_TYPES.INDIVIDUAL.value.toString()
												}
											>
												<div
													className={classNames(
														'"col-xs-12 col-sm-6 form-group',
														{
															"has-error":
																bankAccountInfo.errors.id_number,
														},
													)}
												>
													<label htmlFor="id_number">
														{lang.t("Social Security Number")}
													</label>
													<MaskedInput
														type="tel"
														name="id_number"
														id="id_number"
														className="form-control"
														value={bankAccountInfo.id_number}
														mask={MASK_VALUE.ssnMask}
														onChange={this.handleOnChange(
															"bankAccountInfo",
															"id_number",
														)}
													/>
												</div>
												<div
													className={classNames(
														'"col-xs-12 col-sm-6 form-group',
														{
															"has-error":
																bankAccountInfo.errors.dateOfBirth,
														},
													)}
												>
													<label htmlFor="dateOfBirth">
														{lang.t("Date of Birth (MM/DD/YYYY)")}
													</label>
													<MaskedInput
														type="tel"
														name="dateOfBirth"
														id="dateOfBirth"
														className="form-control"
														value={bankAccountInfo.dateOfBirth}
														mask={MASK_VALUE.dobMask}
														onChange={this.handleOnChange(
															"bankAccountInfo",
															"dateOfBirth",
														)}
													/>
												</div>
											</When>
											<When
												condition={
													bankAccountInfo.account_holder_type ===
													BANK_ACCOUNT_TYPES.COMPANY.value.toString()
												}
											>
												<div
													className={classNames(
														"col-xs-12 col-sm-6 form-group",
														{
															"has-error":
																bankAccountInfo.errors.tax_id,
														},
													)}
												>
													<label htmlFor="tax_id">
														{lang.t("ELVN / Tax ID")}
													</label>
													<input
														type="tel"
														name="tax_id"
														id="tax_id"
														className="form-control"
														value={bankAccountInfo.tax_id}
														onChange={this.handleOnChange(
															"bankAccountInfo",
															"tax_id",
														)}
													/>
												</div>
												<div
													className={classNames(
														"col-xs-12 col-sm-6 form-group",
														{
															"has-error":
																bankAccountInfo.errors.name,
														},
													)}
												>
													<label htmlFor="company-name">
														{lang.t("Company Name")}
													</label>
													<input
														type="text"
														name="company-name"
														id="company-name"
														className="form-control"
														value={bankAccountInfo.name}
														onChange={this.handleOnChange(
															"bankAccountInfo",
															"name",
														)}
													/>
												</div>
											</When>
										</Choose>
										<div
											className={classNames("col-xs-12 form-group", {
												"has-error": bankAccountInfo.errors.line1,
											})}
										>
											<label htmlFor="line1">
												{lang.t("Billing Street Address")}
											</label>
											<input
												type="text"
												name="line1"
												id="line1"
												className="form-control"
												value={bankAccountInfo.line1}
												onChange={this.handleOnChange(
													"bankAccountInfo",
													"line1",
												)}
											/>
										</div>
										<div
											className={classNames("col-xs-12 form-group", {
												"has-error": bankAccountInfo.errors.city,
											})}
										>
											<label htmlFor="city">{lang.t("City")}</label>
											<input
												type="text"
												name="city"
												id="city"
												className="form-control"
												value={bankAccountInfo.city}
												onChange={this.handleOnChange(
													"bankAccountInfo",
													"city",
												)}
											/>
										</div>
										<div
											className={classNames("col-xs-12 col-sm-6 form-group", {
												"has-error": bankAccountInfo.errors.state,
											})}
										>
											<label htmlFor="account-state">{lang.t("State")}</label>
											<StateSelection
												ref={this.accountStateSelection}
												name="state"
												id="account-state"
												value={bankAccountInfo.state}
												onChange={this.handleOnChange(
													"bankAccountInfo",
													"state",
												)}
											/>
										</div>
										<div
											className={classNames("col-xs-12 col-sm-6 form-group", {
												"has-error": bankAccountInfo.errors.postal_code,
											})}
										>
											<label htmlFor="postal_code">
												{lang.t("Zip Code")}
											</label>
											<input
												type="tel"
												name="postal_code"
												id="postal_code"
												className="form-control"
												maxLength="5"
												value={bankAccountInfo.postal_code}
												onChange={this.handleOnChange(
													"bankAccountInfo",
													"postal_code",
												)}
											/>
										</div>
										<div
											className={classNames("col-xs-12 form-group", {
												"has-error": bankAccountInfo.errors.phone,
											})}
										>
											<label htmlFor="account-phone">{lang.t("Phone")}</label>
											<MaskedInput
												type="tel"
												name="account-phone"
												id="account-phone"
												className="form-control"
												value={personalInfo.phone}
												mask={MASK_VALUE.phoneMask}
												onChange={this.handleOnChange(
													"personalInfo",
													"phone",
												)}
											/>
										</div>
										<If
											condition={
												bankAccountInfo.account_holder_type ===
												BANK_ACCOUNT_TYPES.INDIVIDUAL.value.toString()
											}
										>
											<div
												className={classNames("col-xs-12", {
													"has-error":
														bankAccountInfo.errors.photoId ||
														bankAccountInfo.errors.photoPreview,
												})}
											>
												<label
													className="photo-id-label"
													htmlFor="photoId"
												>
													{lang.t("Photo ID (Evidence Quality)")}
												</label>
												<input
													type="file"
													accept=".jpeg,.jpg,.png,.tif,.tiff"
													name="photoId"
													id="photoId"
													onChange={e => this.handleOnPhotoChange(e)}
												/>
												<Image
													src={bankAccountInfo.photoPreview}
													className="img-responsive photo-id-image"
													fallbackSrc="avatar"
												/>
											</div>
											<If condition={!validPhotoIdSelected}>
												<div className="col-xs-12 text-danger">
													{lang.t(
														"Please ensure the selected image has one of the following file extensions:",
													)}
													<br />
													{lang.t("jpeg, jpg, png, tif, tiff")}
												</div>
											</If>
										</If>
										<div
											className={classNames("col-xs-12 form-group", {
												"has-error": bankAccountInfo.errors.fullyAuthorized,
											})}
										>
											<input
												type="checkbox"
												name="fullyAuthorized"
												id="fullyAuthorized"
												checked={bankAccountInfo.fullyAuthorized === true}
												onChange={this.handleOnChange(
													"bankAccountInfo",
													"fullyAuthorized",
												)}
											/>
											<label
												htmlFor="fullyAuthorized"
												className="checkbox-label"
											>
												{lang.t(
													"I attest that I have full authorization to this account",
												)}
											</label>
										</div>
									</When>
									<When condition={step === 2 && subStep === 2}>
										<div className="col-xs-12 form-group">
											<input
												type="checkbox"
												name="TransferPaymentToJurisdiction"
												id="TransferPaymentToJurisdiction"
												checked={
													invoicingInfo.TransferPaymentToJurisdiction ===
													true
												}
												onChange={this.handleOnChange(
													"invoicingInfo",
													"TransferPaymentToJurisdiction",
												)}
											/>
											<label
												className="checkbox-label"
												htmlFor="TransferPaymentToJurisdiction"
											>
												{lang.t("Transfer officer payments to agency")}
											</label>
											<Tooltip
												content={lang.t(
													"The full amount of the invoice will be paid to the agency instead of being distributed to the police officers_",
												)}
											>
												<i className="rkf rkf-question-solid tooltip-icon" />
											</Tooltip>
										</div>
										<div className="col-xs-12 form-group">
											<input
												type="checkbox"
												name="TransferCoordinatorPaymentToJurisdiction"
												id="TransferCoordinatorPaymentToJurisdiction"
												checked={
													invoicingInfo.TransferCoordinatorPaymentToJurisdiction ===
													true
												}
												onChange={this.handleOnChange(
													"invoicingInfo",
													"TransferCoordinatorPaymentToJurisdiction",
												)}
											/>
											<label
												className="checkbox-label"
												htmlFor="TransferCoordinatorPaymentToJurisdiction"
											>
												{lang.t("Transfer coordination fees to agency")}
											</label>
											<Tooltip
												content={lang.t(
													"All coordination fees will be paid to the agency instead of being distributed to individual coordinator_",
												)}
											>
												<i className="rkf rkf-question-solid tooltip-icon" />
											</Tooltip>
										</div>
										<div className="col-xs-12 form-group">
											<input
												type="checkbox"
												name="IsOfficerInvoiceApprovalRequired"
												id="IsOfficerInvoiceApprovalRequired"
												checked={
													invoicingInfo.IsOfficerInvoiceApprovalRequired ===
													true
												}
												onChange={this.handleOnChange(
													"invoicingInfo",
													"IsOfficerInvoiceApprovalRequired",
												)}
											/>
											<label
												className="checkbox-label"
												htmlFor="IsOfficerInvoiceApprovalRequired"
											>
												{lang.t(
													"Review officer invoices prior to client payment",
												)}
											</label>
											<Tooltip
												content={lang.t(
													"Check this box if you would like to review and approve all invoices prior to them being sent to the client_",
												)}
											>
												<i className="rkf rkf-question-solid tooltip-icon" />
											</Tooltip>
										</div>
										<div className="col-xs-12 form-group">
											<input
												type="checkbox"
												name="OfficerInsuranceOptIn"
												id="OfficerInsuranceOptIn"
												checked={invoicingInfo.OfficerInsuranceOptIn}
												onChange={this.handleOnChange(
													"invoicingInfo",
													"OfficerInsuranceOptIn",
												)}
											/>
											<label
												className="checkbox-label"
												htmlFor="OfficerInsuranceOptIn"
											>
												{lang.t(
													"Automatically Opt-In All Officers to Insurance",
												)}
											</label>
										</div>
										<div className="col-xs-12 separator separator-solid" />
										<div className="col-xs-12">
											<div
												className={classNames("col-xs-12 form-group", {
													"has-error": invoicingInfo.errors.generalFees,
												})}
											>
												<div className="row collapsing-panel-header">
													<div className="col-xs-7 col-sm-8 title">
														{lang.t("General Fees")}
													</div>
													<div className="col-xs-3 text-right">
														<button
															type="button"
															className="btn btn-link"
															title="New General Fee"
															onClick={() =>
																this.handleGeneralFeeAdd()
															}
														>
															<span className="visible-xs">{`+ ${lang.t("New")}`}</span>
															<span className="hidden-xs">{`+ ${lang.t("New General Fee")}`}</span>
														</button>
													</div>
													<div className="col-xs-2 col-sm-1 text-right">
														<button
															type="button"
															className="btn btn-link"
															onClick={() => this.toggleGeneralFees()}
															title={
																showGeneralFees
																	? "Hide general fees"
																	: "Show general fees"
															}
														>
															<i
																className={`rkf ${showGeneralFees ? "rkf-chevron-up" : "rkf-chevron-down"}`}
															/>
														</button>
													</div>
												</div>
												<div
													className={`container-fluid collapsing-panel${showGeneralFees ? " expanded" : ""}`}
												>
													<If
														condition={
															invoicingInfo.jurisdictionFees
																.generalFees.length === 0
														}
													>
														<div className="row">
															<div className="col-xs-12 text-muted text-center">
																{lang.t("No fees added")}
															</div>
														</div>
													</If>
													<For
														each="fee"
														of={
															invoicingInfo.jurisdictionFees
																.generalFees
														}
														index="index"
													>
														<div
															className="row"
															key={
																fee.Id
																	? `jurisdiction-fee_${fee.Id}`
																	: `new-jurisdiction-fee_${index}`
															}
														>
															<div className="col-xs-10 col-sm-6 col-md-7 form-group">
																<input
																	id={`jurisdiction-fee${index}`}
																	name={`jurisdiction-fee${index}`}
																	placeholder={lang.t(
																		"Description",
																	)}
																	className="form-control"
																	value={fee.Description}
																	onChange={this.handleGeneralFeeChange(
																		index,
																		"Description",
																	)}
																/>
															</div>
															<div className="fee-rate form-group col-xs-10 col-sm-5 col-md-4">
																<input
																	className="rate-input form-control"
																	type="tel"
																	min="1"
																	placeholder="Rate"
																	value={fee.Rate}
																	onChange={this.handleGeneralFeeChange(
																		index,
																		"Rate",
																	)}
																/>
																<select
																	className="rate-type-input form-control"
																	value={fee.JurisdictionFeeType}
																	onChange={this.handleGeneralFeeChange(
																		index,
																		"JurisdictionFeeType",
																	)}
																>
																	<For
																		each="option"
																		of={JURISDICTION_FEE_TYPES}
																	>
																		<option
																			key={`rate-type_${option.value}`}
																			value={option.value}
																		>
																			{option.label}
																		</option>
																	</For>
																</select>
															</div>
															<div className="col-xs-2 col-sm-1 text-right">
																<Tooltip
																	content={lang.t("Delete Fee")}
																	placement="top"
																>
																	<button
																		type="button"
																		className="btn btn-link"
																		onClick={() =>
																			this.handleGeneralFeeDelete(
																				index,
																			)
																		}
																	>
																		<i className="rkf rkf-trash text-danger" />
																	</button>
																</Tooltip>
															</div>
														</div>
													</For>
												</div>
											</div>

											<div className="col-xs-12 separator separator-solid" />

											<div
												className={classNames("col-xs-12 form-group", {
													"has-error": invoicingInfo.errors.vehicleFees,
												})}
											>
												<div className="row collapsing-panel-header">
													<div className="col-xs-7 col-sm-8 title">
														{lang.t("Vehicle Fees")}
													</div>
													<div className="col-xs-3 text-right">
														<button
															type="button"
															className="btn btn-link"
															title={lang.t("New Vehicle Fee")}
															onClick={() => this.handleVehicleAdd()}
														>
															<span className="visible-xs">{`+ ${lang.t("New")}`}</span>
															<span className="hidden-xs">{`+ ${lang.t("New Vehicle Fee")}`}</span>
														</button>
													</div>
													<div className="col-xs-2 col-sm-1 text-right">
														<button
															type="button"
															className="btn btn-link"
															onClick={() => this.toggleVehicleFees()}
															title={
																showVehicleFees
																	? "Hide vehicle fees"
																	: "Show vehicle fees"
															}
														>
															<i
																className={`rkf ${showVehicleFees ? "rkf-chevron-up" : "rkf-chevron-down"}`}
															/>
														</button>
													</div>
												</div>
												<div
													className={`container-fluid collapsing-panel${showVehicleFees ? " expanded" : ""}`}
												>
													<If
														condition={
															invoicingInfo.jurisdictionFees
																.vehicleFees.length === 0
														}
													>
														<div className="row">
															<div className="col-xs-12 text-muted text-center">
																{lang.t("No fees added")}
															</div>
														</div>
													</If>
													<For
														each="vehicle"
														of={
															invoicingInfo.jurisdictionFees
																.vehicleFees
														}
														index="index"
													>
														<div
															className="row"
															key={
																vehicle.Id
																	? `vehicle-fee${vehicle.Id}`
																	: `new-vehicle-fee_${index}`
															}
														>
															<div className="col-xs-10 col-sm-6 col-md-7 form-group">
																<select
																	id={`vehicle-options${index}`}
																	className="form-control"
																	value={vehicle.VehicleTypeId}
																	onChange={this.handleVehicleFeeChange(
																		index,
																		"VehicleTypeId",
																	)}
																>
																	<If
																		condition={
																			vehicle.VehicleTypeId ===
																			""
																		}
																	>
																		<option value="">--</option>
																	</If>
																	<For
																		each="option"
																		of={vehicleTypes}
																	>
																		<option
																			key={`vehicle-type${option.Id}`}
																			value={option.Id}
																		>
																			{option.Name}
																		</option>
																	</For>
																</select>
															</div>
															<div className="fee-rate form-group col-xs-10 col-sm-5 col-md-4">
																<input
																	className="rate-input form-control"
																	type="tel"
																	min="1"
																	placeholder="Rate"
																	value={vehicle.Rate}
																	onChange={this.handleVehicleFeeChange(
																		index,
																		"Rate",
																	)}
																/>
																<select
																	className="rate-type-input form-control"
																	value={
																		vehicle.JurisdictionFeeType
																	}
																	onChange={this.handleVehicleFeeChange(
																		index,
																		"JurisdictionFeeType",
																	)}
																>
																	<For
																		each="option"
																		of={JURISDICTION_FEE_TYPES}
																	>
																		<option
																			key={`rate-type_${option.value}`}
																			value={option.value}
																		>
																			{option.label}
																		</option>
																	</For>
																</select>
															</div>
															<div className="col-xs-2 col-sm-1 text-right">
																<Tooltip
																	content={lang.t("Delete Fee")}
																	placement="top"
																>
																	<button
																		type="button"
																		className="btn btn-link"
																		onClick={() =>
																			this.handleVehicleDelete(
																				index,
																			)
																		}
																	>
																		<i className="rkf rkf-trash text-danger" />
																	</button>
																</Tooltip>
															</div>
														</div>
													</For>
												</div>
											</div>
										</div>
									</When>
									<When condition={step === 3 && subStep === 1}>
										<div>
											<div className="col-sm-3 hidden-xs">
												<span>{lang.t("Location Restriction")}</span>
											</div>

											<div className="col-sm-9 form-group">
												<div>
													{lang.t(
														"Are there any types of venues that officers are not permitted to work_",
													)}
												</div>
												<div className="row radio-group">
													<div className="col-xs-3 col-md-2 radio">
														<input
															type="radio"
															name="IsJobLocationTypeRestricted"
															id="IsJobLocationTypeRestricted-no"
															checked={
																agencyRules.IsJobLocationTypeRestricted ===
																false
															}
															onChange={() =>
																this.handleCheckboxChange(
																	"agencyRules",
																	"IsJobLocationTypeRestricted",
																	false,
																)
															}
														/>
														<label htmlFor="IsJobLocationTypeRestricted-no">
															{lang.t("No")}
														</label>
													</div>
													<div className="col-xs-3 col-md-2 radio">
														<input
															type="radio"
															name="IsJobLocationTypeRestricted"
															id="IsJobLocationTypeRestricted-yes"
															checked={
																agencyRules.IsJobLocationTypeRestricted ===
																true
															}
															onChange={() =>
																this.handleCheckboxChange(
																	"agencyRules",
																	"IsJobLocationTypeRestricted",
																	true,
																)
															}
														/>
														<label htmlFor="IsJobLocationTypeRestricted-yes">
															{lang.t("Yes")}
														</label>
													</div>
												</div>
											</div>
										</div>
										<If
											condition={
												agencyRules.IsJobLocationTypeRestricted === true
											}
										>
											<div className="col-xs-12">
												{lang.t(
													"Please select all the categories of establishments that apply",
												)}
											</div>
											<div className="row">
												<For
													each="item"
													of={locationTypes}
													index="index"
												>
													<div
														className="col-xs-12 col-sm-6 col-md-4"
														key={`location_type_${item.value}`}
													>
														<input
															type="checkbox"
															name={`RestrictedJobLocationTypes-${item.value}`}
															id={`RestrictedJobLocationTypes-${item.value}`}
															checked={agencyRules.RestrictedJobLocationTypes.includes(
																item.value,
															)}
															onChange={this.handleLocationTypeChange(
																item.value,
															)}
														/>
														<label
															className="checkbox-label"
															htmlFor={`RestrictedJobLocationTypes-${item.value}`}
														>
															{item.label}
														</label>
													</div>
												</For>
											</div>
										</If>
										<div className="col-xs-12 separator separator-solid" />
										<div>
											<div className="col-sm-3 hidden-xs">
												<span className="hidden-xs">
													{lang.t("Location Approval")}
												</span>
											</div>
											<div className="col-sm-9 form-group">
												<div>
													{lang.t(
														"Do you require that a location receive approval prior to your officers working at the location_",
													)}
												</div>
												<div className="row radio-group">
													<div className="col-xs-3 col-md-2 radio">
														<input
															type="radio"
															name="IsJobLocationApprovalRequired-no"
															id="IsJobLocationApprovalRequired-no"
															checked={
																agencyRules.IsJobLocationApprovalRequired ===
																false
															}
															onChange={() =>
																this.handleCheckboxChange(
																	"agencyRules",
																	"IsJobLocationApprovalRequired",
																	false,
																)
															}
														/>
														<label htmlFor="IsJobLocationApprovalRequired-no">
															{lang.t("No")}
														</label>
													</div>
													<div className="col-xs-3 col-md-2 radio">
														<input
															type="radio"
															name="IsJobLocationApprovalRequired-yes"
															id="IsJobLocationApprovalRequired-yes"
															checked={
																agencyRules.IsJobLocationApprovalRequired ===
																true
															}
															onChange={() =>
																this.handleCheckboxChange(
																	"agencyRules",
																	"IsJobLocationApprovalRequired",
																	true,
																)
															}
														/>
														<label htmlFor="IsJobLocationApprovalRequired-yes">
															{lang.t("Yes")}
														</label>
													</div>
												</div>
											</div>
										</div>
									</When>
									<When condition={step === 3 && subStep === 2}>
										<div className="col-sm-3 hidden-xs">
											{lang.t("Hourly Restrictions")}
										</div>
										<div className="col-sm-9 form-group">
											<div>
												{lang.t(
													"Do you limit the number of hours your officers can work_",
												)}
											</div>
											<div className="row radio-group">
												<div className="col-xs-3 col-sm-2 radio">
													<input
														type="radio"
														name="limitedHours"
														id="limitedHours-no"
														checked={
															officerRules.limitedHours === false
														}
														onChange={() =>
															this.handleCheckboxChange(
																"officerRules",
																"limitedHours",
																false,
															)
														}
													/>
													<label htmlFor="limitedHours-no">
														{lang.t("No")}
													</label>
												</div>
												<div className="col-xs-3 col-sm-2 radio">
													<input
														type="radio"
														name="limitedHours"
														id="limitedHours-yes"
														checked={officerRules.limitedHours === true}
														onChange={() =>
															this.handleCheckboxChange(
																"officerRules",
																"limitedHours",
																true,
															)
														}
													/>
													<label htmlFor="limitedHours-yes">
														{lang.t("Yes")}
													</label>
												</div>
											</div>
										</div>
										<If condition={officerRules.limitedHours === true}>
											<div className="col-xs-10 col-xs-offset-2 col-sm-8 col-sm-offset-4 radio">
												<input
													type="radio"
													name="MaxWeeklyHoursType"
													id="MaxWeeklyHoursType-1"
													checked={officerRules.MaxWeeklyHoursType === 1}
													onChange={() =>
														this.handleCheckboxChange(
															"officerRules",
															"MaxWeeklyHoursType",
															1,
														)
													}
												/>
												<label htmlFor="MaxWeeklyHoursType-1">
													{lang.t("Monday to Sunday")}
												</label>
											</div>
											<div className="col-xs-10 col-xs-offset-2 col-sm-8 col-sm-offset-4 radio">
												<input
													type="radio"
													name="MaxWeeklyHoursType"
													id="MaxWeeklyHoursType-2"
													checked={officerRules.MaxWeeklyHoursType === 2}
													onChange={() =>
														this.handleCheckboxChange(
															"officerRules",
															"MaxWeeklyHoursType",
															2,
														)
													}
												/>
												<label htmlFor="MaxWeeklyHoursType-2">
													{lang.t("Sunday to Saturday")}
												</label>
											</div>
											<div className="col-sm-6 col-sm-offset-4">
												<div>
													{lang.t(
														"How many hours do you limit your officers to per week_",
													)}
												</div>
												<input
													type="number"
													name="MaxWeeklyHours"
													className="form-control"
													min="1"
													value={officerRules.MaxWeeklyHours}
													onChange={this.handleOnChange(
														"officerRules",
														"MaxWeeklyHours",
													)}
												/>
											</div>
										</If>

										<div className="col-xs-12 separator separator-solid" />

										<div>
											<div className="col-sm-3 hidden-xs">
												<span className="hidden-xs">
													{lang.t("Supervisor Approvals")}
												</span>
											</div>
											<div className="col-sm-9 form-group">
												<div>
													{lang.t(
														"Are officers required to receive permission from their supervisor prior to working an extra duty job_",
													)}
												</div>
												<div className="row radio-group">
													<div className="col-xs-3 col-sm-2 radio">
														<input
															type="radio"
															name="ExtraDutyApprovalRequired"
															id="ExtraDutyApprovalRequired-no"
															checked={
																officerRules.ExtraDutyApprovalRequired ===
																false
															}
															onChange={() =>
																this.handleCheckboxChange(
																	"officerRules",
																	"ExtraDutyApprovalRequired",
																	false,
																)
															}
														/>
														<label htmlFor="ExtraDutyApprovalRequired-no">
															{lang.t("No")}
														</label>
													</div>
													<div className="col-xs-3 col-sm-2 radio">
														<input
															type="radio"
															name="ExtraDutyApprovalRequired"
															id="ExtraDutyApprovalRequired-yes"
															checked={
																officerRules.ExtraDutyApprovalRequired ===
																true
															}
															onChange={() =>
																this.handleCheckboxChange(
																	"officerRules",
																	"ExtraDutyApprovalRequired",
																	true,
																)
															}
														/>
														<label htmlFor="ExtraDutyApprovalRequired-yes">
															{lang.t("Yes")}
														</label>
													</div>
												</div>
											</div>
										</div>

										<div className="col-xs-12 separator separator-solid" />

										<div>
											<div className="col-sm-3 hidden-xs">
												<div>
													{lang.t("Officer Approval & Assignment Rules")}
												</div>
												<small className="officer-rules-subtext">
													{lang.t(
														"Control how jobs are posted and assigned_",
													)}
												</small>
											</div>
											<div className="col-sm-9">
												<div className="form-group radio-group">
													<div className="radio radio-group">
														<input
															type="radio"
															name="JobAutoAssignType-1"
															id="JobAutoAssignType-1"
															value="1"
															checked={
																officerRules.JobAutoAssignType ===
																"1"
															}
															onChange={() =>
																this.handleCheckboxChange(
																	"officerRules",
																	"JobAutoAssignType",
																	"1",
																)
															}
														/>
														<label htmlFor="JobAutoAssignType-1">
															{lang.t("Assign Manually")}
														</label>
														<Tooltip
															content={`
															${lang.t("Officers can apply for the job, and will be shown to you in a list_")}
															${lang.t("You will then have to manually select the officer you wish to assign to the job_")}
															`}
														>
															<i className="rkf rkf-question-solid tooltip-icon" />
														</Tooltip>
													</div>
													<div className="radio radio-group">
														<input
															type="radio"
															name="JobAutoAssignType-2"
															id="JobAutoAssignType-2"
															value="2"
															checked={
																officerRules.JobAutoAssignType ===
																"2"
															}
															onChange={() =>
																this.handleCheckboxChange(
																	"officerRules",
																	"JobAutoAssignType",
																	"2",
																)
															}
														/>
														<label htmlFor="JobAutoAssignType-2">
															{lang.t(
																"Based on first-come first-serve rule",
															)}
														</label>
														<Tooltip
															content={lang.t(
																"The first officer to apply for the job will be accepted_",
															)}
														>
															<i className="rkf rkf-question-solid tooltip-icon" />
														</Tooltip>
													</div>

													<div className="radio radio-group">
														<input
															type="radio"
															name="JobAutoAssignType-3"
															id="JobAutoAssignType-3"
															value="3"
															checked={
																officerRules.JobAutoAssignType ===
																"3"
															}
															onChange={() =>
																this.handleCheckboxChange(
																	"officerRules",
																	"JobAutoAssignType",
																	"3",
																)
															}
														/>
														<label htmlFor="JobAutoAssignType-3">
															{lang.t("By hours")}
														</label>
														<Tooltip
															content={lang.t(
																"Officers can apply for the job, which will then be automatically assigned to the officer with the fewest number of hours_",
															)}
														>
															<i className="rkf rkf-question-solid tooltip-icon" />
														</Tooltip>
													</div>
													<If
														condition={
															officerRules.JobAutoAssignType === "3"
														}
													>
														<div className="row row-align">
															<div className="col-xs-3 col-md-4 col-lg-3 col-sm-offset-1">
																{`${lang.t("Sign-Up Period")}:`}
															</div>
															<div
																className={classNames(
																	"col-xs-3 col-sm-2 form-group",
																	{
																		"has-error":
																			officerRules.errors
																				.JobAutoAssignHoursSpan,
																	},
																)}
															>
																<input
																	type="number"
																	name="JobAutoAssignHoursSpan"
																	id="JobAutoAssignHoursSpan-1"
																	className="form-control"
																	min={1}
																	placeholder={1}
																	value={
																		officerRules.JobAutoAssignHoursSpan
																	}
																	onChange={this.handleOnChange(
																		"officerRules",
																		"JobAutoAssignHoursSpan",
																	)}
																/>
															</div>
															<div className="col-xs-6 col-md-5 form-group">
																<select
																	name="signUpPeriodHoursMultiplier"
																	id="signUpPeriodHoursMultiplier-1"
																	className="form-control"
																	placeholder={lang.t(
																		"Hours or days_",
																	)}
																	onChange={this.handleOnChange(
																		"officerRules",
																		"signUpPeriodHoursMultiplier",
																	)}
																>
																	<For
																		each="item"
																		of={
																			this
																				.signUpPeriodTimeTypeOptions
																		}
																		index="index"
																	>
																		<option
																			key={`signUpPeriod_${index}_${item.value}`}
																			value={item.value}
																		>
																			{item.label}
																		</option>
																	</For>
																</select>
															</div>
														</div>
														<div className="row row-align">
															<div className="col-xs-11 col-sm-offset-1 space-below">
																{`${lang.t("Time to Consider")}:`}
															</div>
															<div className="col-xs-2 col-xs-offset-2">
																<div className="radio">
																	<label htmlFor="JobAutoAssignYearToDateSpan-1">
																		<input
																			type="radio"
																			name="JobAutoAssignYearToDateSpan-1"
																			id="JobAutoAssignYearToDateSpan-1"
																			checked={
																				officerRules.JobAutoAssignYearToDateSpan ===
																				true
																			}
																			onChange={() =>
																				this.handleCheckboxChange(
																					"officerRules",
																					"JobAutoAssignYearToDateSpan",
																					true,
																				)
																			}
																		/>
																		{`${lang.t("Days")}:`}
																	</label>
																</div>
															</div>
															<div
																className={classNames(
																	"col-xs-4 col-xs-3 form-group",
																	{
																		"has-error":
																			officerRules.errors
																				.JobAutoAssignJobCountDaysSpan,
																	},
																)}
															>
																<label htmlFor="JobAutoAssignJobCountDaysSpan-1">
																	<input
																		type="number"
																		name="JobAutoAssignJobCountDaysSpan-1"
																		id="JobAutoAssignJobCountDaysSpan-1"
																		className="form-control"
																		min={1}
																		placeholder={1}
																		disabled={
																			officerRules.JobAutoAssignYearToDateSpan ===
																			false
																		}
																		value={
																			officerRules.JobAutoAssignJobCountDaysSpan
																		}
																		onChange={this.handleOnChange(
																			"officerRules",
																			"JobAutoAssignJobCountDaysSpan",
																		)}
																	/>
																</label>
															</div>
															<div className="col-xs-6" />
															<div className="col-xs-10 col-xs-offset-2">
																<div className="radio">
																	<label htmlFor="JobAutoAssignYearToDateSpan-2">
																		<input
																			type="radio"
																			name="JobAutoAssignYearToDateSpan-2"
																			id="JobAutoAssignYearToDateSpan-2"
																			checked={
																				officerRules.JobAutoAssignYearToDateSpan ===
																				false
																			}
																			onChange={() =>
																				this.handleCheckboxChange(
																					"officerRules",
																					"JobAutoAssignYearToDateSpan",
																					false,
																				)
																			}
																		/>
																		{lang.t("Year to Date")}
																	</label>
																</div>
															</div>
														</div>
													</If>
													<div className="radio radio-group">
														<input
															type="radio"
															name="JobAutoAssignType=4"
															value="4"
															id="JobAutoAssignType-4"
															checked={
																officerRules.JobAutoAssignType ===
																"4"
															}
															onChange={() =>
																this.handleCheckboxChange(
																	"officerRules",
																	"JobAutoAssignType",
																	"4",
																)
															}
														/>
														<label htmlFor="JobAutoAssignType-4">
															{lang.t("By number of jobs")}
														</label>
														<Tooltip
															content={lang.t(
																"Officers can apply for the job, which will then be automatically assigned to the officer with the fewest number of jobs_",
															)}
														>
															<i className="rkf rkf-question-solid tooltip-icon" />
														</Tooltip>
													</div>
													<If
														condition={
															officerRules.JobAutoAssignType === "4"
														}
													>
														<div className="row row-align">
															<div className="col-xs-3 col-md-4 col-lg-3 col-sm-offset-1">
																{`${lang.t("Sign-Up Period")}:`}
															</div>
															<div
																className={classNames(
																	"col-xs-3 col-sm-2 form-group",
																	{
																		"has-error":
																			officerRules.errors
																				.JobAutoAssignHoursSpan,
																	},
																)}
															>
																<input
																	type="number"
																	name="JobAutoAssignHoursSpan"
																	id="JobAutoAssignHoursSpan-2"
																	className="form-control"
																	min={1}
																	placeholder={1}
																	value={
																		officerRules.JobAutoAssignHoursSpan
																	}
																	onChange={this.handleOnChange(
																		"officerRules",
																		"JobAutoAssignHoursSpan",
																	)}
																/>
															</div>
															<div className="col-xs-6 col-md-5 form-group">
																<select
																	name="signUpPeriodHoursMultiplier"
																	id="signUpPeriodHoursMultiplier-1"
																	className="form-control"
																	placeholder={lang.t(
																		"Hours or days_",
																	)}
																	onChange={this.handleOnChange(
																		"officerRules",
																		"signUpPeriodHoursMultiplier",
																	)}
																>
																	<For
																		each="item"
																		of={
																			this
																				.signUpPeriodTimeTypeOptions
																		}
																		index="index"
																	>
																		<option
																			key={`signUpPeriod_${index}_${item.value}`}
																			value={item.value}
																		>
																			{item.label}
																		</option>
																	</For>
																</select>
															</div>
														</div>
														<div className="row ">
															<div className="col-xs-11 col-sm-offset-1 space-below">
																{`${lang.t("Time to Consider")}:`}
															</div>
															<div className="col-xs-2 col-xs-offset-2">
																<div className="radio">
																	<label htmlFor="JobAutoAssignYearToDateSpan-3">
																		<input
																			type="radio"
																			name="JobAutoAssignYearToDateSpan-3"
																			id="JobAutoAssignYearToDateSpan-3"
																			checked={
																				officerRules.JobAutoAssignYearToDateSpan ===
																				true
																			}
																			onChange={() =>
																				this.handleCheckboxChange(
																					"officerRules",
																					"JobAutoAssignYearToDateSpan",
																					true,
																				)
																			}
																		/>
																		{`${lang.t("Days")}:`}
																	</label>
																</div>
															</div>
															<div
																className={classNames(
																	"col-xs-4 col-xs-3 form-group",
																	{
																		"has-error":
																			officerRules.errors
																				.JobAutoAssignJobCountDaysSpan,
																	},
																)}
															>
																<label htmlFor="JobAutoAssignJobCountDaysSpan-2">
																	<input
																		type="number"
																		name="JobAutoAssignJobCountDaysSpan-2"
																		id="JobAutoAssignJobCountDaysSpan-2"
																		className="form-control"
																		min={1}
																		placeholder={1}
																		disabled={
																			officerRules.JobAutoAssignYearToDateSpan ===
																			false
																		}
																		value={
																			officerRules.JobAutoAssignJobCountDaysSpan
																		}
																		onChange={this.handleOnChange(
																			"officerRules",
																			"JobAutoAssignJobCountDaysSpan",
																		)}
																	/>
																</label>
															</div>
															<div className="col-xs-6" />
															<div className="col-xs-10 col-xs-offset-2">
																<div className="radio">
																	<label htmlFor="JobAutoAssignYearToDateSpan-4">
																		<input
																			type="radio"
																			name="JobAutoAssignYearToDateSpan-4"
																			id="JobAutoAssignYearToDateSpan-4"
																			checked={
																				officerRules.JobAutoAssignYearToDateSpan ===
																				false
																			}
																			onChange={() =>
																				this.handleCheckboxChange(
																					"officerRules",
																					"JobAutoAssignYearToDateSpan",
																					false,
																				)
																			}
																		/>
																		{lang.t("Year to Date")}
																	</label>
																</div>
															</div>
														</div>
													</If>

													<div className="radio radio-group">
														<input
															type="radio"
															name="JobAutoAssignType-5"
															id="JobAutoAssignType-5"
															value="5"
															checked={
																officerRules.JobAutoAssignType ===
																"5"
															}
															onChange={() =>
																this.handleCheckboxChange(
																	"officerRules",
																	"JobAutoAssignType",
																	"5",
																)
															}
														/>
														<label htmlFor="JobAutoAssignType-5">
															{lang.t("By Seniority (Descending)")}
														</label>
														<Tooltip
															content={lang.t(
																"Most senior officers first",
															)}
														>
															<i className="rkf rkf-question-solid tooltip-icon" />
														</Tooltip>
													</div>
													<If
														condition={
															officerRules.JobAutoAssignType === "5"
														}
													>
														<div className="row row-align">
															<div className="col-xs-3 col-md-4 col-lg-3 col-sm-offset-1">
																{`${lang.t("Sign-Up Period")}:`}
															</div>
															<div
																className={classNames(
																	"col-xs-3 col-sm-2 form-group",
																	{
																		"has-error":
																			officerRules.errors
																				.JobAutoAssignHoursSpan,
																	},
																)}
															>
																<input
																	type="number"
																	name="JobAutoAssignHoursSpan"
																	id="JobAutoAssignHoursSpan-3"
																	className="form-control"
																	min={1}
																	placeholder={1}
																	value={
																		officerRules.JobAutoAssignHoursSpan
																	}
																	onChange={this.handleOnChange(
																		"officerRules",
																		"JobAutoAssignHoursSpan",
																	)}
																/>
															</div>
															<div className="col-xs-6 col-md-5 form-group">
																<select
																	name="signUpPeriodHoursMultiplier"
																	id="signUpPeriodHoursMultiplier-3"
																	className="form-control"
																	placeholder={lang.t(
																		"Hours or days_",
																	)}
																	onChange={this.handleOnChange(
																		"officerRules",
																		"signUpPeriodHoursMultiplier",
																	)}
																>
																	<For
																		each="item"
																		of={
																			this
																				.signUpPeriodTimeTypeOptions
																		}
																		index="index"
																	>
																		<option
																			key={`signUpPeriod_${index}_${item.value}`}
																			value={item.value}
																		>
																			{item.label}
																		</option>
																	</For>
																</select>
															</div>
														</div>
													</If>

													<div className="radio radio-group">
														<input
															type="radio"
															name="JobAutoAssignType-6"
															id="JobAutoAssignType-6"
															value="6"
															checked={
																officerRules.JobAutoAssignType ===
																"6"
															}
															onChange={() =>
																this.handleCheckboxChange(
																	"officerRules",
																	"JobAutoAssignType",
																	"6",
																)
															}
														/>
														<label htmlFor="JobAutoAssignType-6">
															{lang.t("By Seniority (Ascending)")}
														</label>
														<Tooltip
															content={lang.t(
																"Officers with least number of years first",
															)}
														>
															<i className="rkf rkf-question-solid tooltip-icon" />
														</Tooltip>
													</div>
													<If
														condition={
															officerRules.JobAutoAssignType === "6"
														}
													>
														<div className="row row-align">
															<div className="col-xs-3 col-md-4 col-lg-3 col-sm-offset-1">
																{`${lang.t("Sign-Up Period")}:`}
															</div>
															<div
																className={classNames(
																	"col-xs-3 col-sm-2 form-group",
																	{
																		"has-error":
																			officerRules.errors
																				.JobAutoAssignHoursSpan,
																	},
																)}
															>
																<input
																	type="number"
																	name="JobAutoAssignHoursSpan"
																	id="JobAutoAssignHoursSpan-4"
																	className="form-control"
																	min={1}
																	placeholder={1}
																	value={
																		officerRules.JobAutoAssignHoursSpan
																	}
																	onChange={this.handleOnChange(
																		"officerRules",
																		"JobAutoAssignHoursSpan",
																	)}
																/>
															</div>
															<div className="col-xs-6 col-md-5 form-group">
																<select
																	name="signUpPeriodHoursMultiplier"
																	id="signUpPeriodHoursMultiplier-4"
																	className="form-control"
																	placeholder={lang.t(
																		"Hours or days_",
																	)}
																	onChange={this.handleOnChange(
																		"officerRules",
																		"signUpPeriodHoursMultiplier",
																	)}
																>
																	<For
																		each="item"
																		of={
																			this
																				.signUpPeriodTimeTypeOptions
																		}
																		index="index"
																	>
																		<option
																			key={`signUpPeriod_${index}_${item.value}`}
																			value={item.value}
																		>
																			{item.label}
																		</option>
																	</For>
																</select>
															</div>
														</div>
													</If>
													<div className="radio radio-group">
														<input
															type="radio"
															name="JobAutoAssignType-7"
															id="JobAutoAssignType-7"
															value="7"
															checked={
																officerRules.JobAutoAssignType ===
																"7"
															}
															onChange={() =>
																this.handleCheckboxChange(
																	"officerRules",
																	"JobAutoAssignType",
																	"7",
																)
															}
														/>
														<label htmlFor="JobAutoAssignType-7">
															{lang.t("Randomly")}
														</label>
														<Tooltip
															content={lang.t(
																"Officers will be assigned randomly after the signup period is closed",
															)}
														>
															<i className="rkf rkf-question-solid tooltip-icon" />
														</Tooltip>
													</div>
													<If
														condition={
															officerRules.JobAutoAssignType === "7"
														}
													>
														<div className="row row-align">
															<div className="col-xs-3 col-md-4 col-lg-3 col-sm-offset-1">
																{`${lang.t("Sign-Up Period")}:`}
															</div>
															<div
																className={classNames(
																	"col-xs-3 col-sm-2 form-group",
																	{
																		"has-error":
																			officerRules.errors
																				.JobAutoAssignHoursSpan,
																	},
																)}
															>
																<input
																	type="number"
																	name="JobAutoAssignHoursSpan"
																	id="JobAutoAssignHoursSpan-5"
																	className="form-control"
																	min={1}
																	placeholder={1}
																	value={
																		officerRules.JobAutoAssignHoursSpan
																	}
																	onChange={this.handleOnChange(
																		"officerRules",
																		"JobAutoAssignHoursSpan",
																	)}
																/>
															</div>
															<div className="col-xs-6 col-md-5 form-group">
																<select
																	name="signUpPeriodHoursMultiplier"
																	id="signUpPeriodHoursMultiplier-5"
																	className="form-control"
																	placeholder={lang.t(
																		"Hours or days_",
																	)}
																	onChange={this.handleOnChange(
																		"officerRules",
																		"signUpPeriodHoursMultiplier",
																	)}
																>
																	<For
																		each="item"
																		of={
																			this
																				.signUpPeriodTimeTypeOptions
																		}
																		index="index"
																	>
																		<option
																			key={`signUpPeriod_${index}_${item.value}`}
																			value={item.value}
																		>
																			{item.label}
																		</option>
																	</For>
																</select>
															</div>
														</div>
													</If>
												</div>
											</div>
										</div>

										<div className="col-xs-12 separator separator-solid" />
										<div>
											<div className="col-sm-3 hidden-xs">
												<div>
													{lang.t("Officer Call Off and Replacement")}
												</div>
												<small className="officer-rules-subtext">
													{lang.t(
														"Allow or disallow officers to call off upcoming duties/schedules_",
													)}
												</small>
											</div>
											<div className="col-sm-9">
												<div className="form-group radio-group">
													<div className="radio radio-group">
														<input
															type="radio"
															name="JobCallOffType"
															id="JobCallOffType"
															value=""
															checked={
																officerRules.JobCallOffType === ""
															}
															onChange={() =>
																this.handleCheckboxChange(
																	"officerRules",
																	"JobCallOffType",
																	"",
																)
															}
														/>
														<label htmlFor="JobCallOffType">
															{lang.t("Have Officers Call")}
														</label>
														<Tooltip
															content={lang.t(
																"The officer will be required to call you in order to call off_",
															)}
														>
															<i className="rkf rkf-question-solid tooltip-icon" />
														</Tooltip>
													</div>
													<div className="radio radio-group">
														<input
															type="radio"
															name="JobCallOffType-1"
															id="JobCallOffType-1"
															value="1"
															checked={
																officerRules.JobCallOffType === "1"
															}
															onChange={() =>
																this.handleCheckboxChange(
																	"officerRules",
																	"JobCallOffType",
																	"1",
																)
															}
														/>
														<label htmlFor="JobCallOffType-1">
															{lang.t("Remove Completely")}
														</label>
														<Tooltip
															content={`
															${lang.t("This will allow an officer to be able to remove themselves completely from a job_")}
															${lang.t("The job becomes available to be re-assigned to a new officer_")}
															`}
														>
															<i className="rkf rkf-question-solid tooltip-icon" />
														</Tooltip>
													</div>
													<div className="radio radio-group">
														<input
															type="radio"
															name="JobCallOffType-2"
															id="JobCallOffType-2"
															value="2"
															checked={
																officerRules.JobCallOffType === "2"
															}
															onChange={() =>
																this.handleCheckboxChange(
																	"officerRules",
																	"JobCallOffType",
																	"2",
																)
															}
														/>
														<label htmlFor="JobCallOffType-2">
															{lang.t(
																"Remove if Replacement is Found",
															)}
														</label>
														<Tooltip
															content={lang.t(
																"This will allow the officer to be removed from the job only if a replacement is found within the specified Call Off Range_",
															)}
														>
															<i className="rkf rkf-question-solid tooltip-icon" />
														</Tooltip>
													</div>
													<If
														condition={
															officerRules.JobCallOffType === "2"
														}
													>
														<div className="row form-group">
															<div className="col-xs-12 col-sm-11 col-sm-offset-1">
																{lang.t(
																	"How would you like the officers to request replacement_",
																)}
															</div>
															<div className="col-xs-10 col-xs-offset-2 col-sm-11 col-sm-offset-1 checkbox">
																<label htmlFor="selectReplacement">
																	<input
																		type="checkbox"
																		name="selectReplacement"
																		id="selectReplacement"
																		value={1}
																		onChange={
																			this
																				.handleReplacementTypeChange
																		}
																		checked={officerRules.JobCallOffReplacementTypes.includes(
																			1,
																		)}
																	/>
																	{lang.t(
																		"Search and select a specific replacement",
																	)}
																</label>
															</div>
															<div className="col-xs-10 col-xs-offset-2 col-sm-11 col-sm-offset-1 checkbox">
																<label htmlFor="repostJob">
																	<input
																		type="checkbox"
																		name="repostJob"
																		id="repostJob"
																		value={2}
																		onChange={
																			this
																				.handleReplacementTypeChange
																		}
																		checked={officerRules.JobCallOffReplacementTypes.includes(
																			2,
																		)}
																	/>
																	{lang.t(
																		"Repost the job to all eligible officers",
																	)}
																</label>
															</div>
														</div>
													</If>
													<div className="row">
														<div className="col-sm-6 form-group">
															<span>{lang.t("Call Off Range")}</span>
															<Tooltip
																content={lang.t(
																	"The amount of time in advance an officer can call-off for a job",
																)}
															>
																<i className="rkf rkf-question-solid tooltip-icon" />
															</Tooltip>
															<select
																id="JobCallOffExpirationMinutes"
																className="form-control"
																name="JobCallOffExpirationMinutes"
																value={
																	officerRules.JobCallOffExpirationMinutes
																}
																onChange={this.handleOnChange(
																	"officerRules",
																	"JobCallOffExpirationMinutes",
																)}
															>
																{this.callOffTimes.map(item => (
																	<option
																		key={item.label}
																		value={item.value}
																	>
																		{item.label}
																	</option>
																))}
															</select>
														</div>
													</div>
												</div>
											</div>
										</div>

										<div className="col-xs-12 separator separator-solid" />

										<div>
											<div className="col-sm-3 hidden-xs">
												<span className="hidden-xs">
													{lang.t("Agency Restrictions")}
												</span>
											</div>
											<div className="col-sm-9">
												<div className="form-group radio-group">
													<div className="radio radio-group">
														<label htmlFor="job-restriction-0">
															<input
																type="radio"
																name="job-restriction-options"
																id="job-restriction-0"
																onChange={this.handleJobRestrictionTypeChange(
																	0,
																)}
																checked={
																	officerRules.JobRestrictionType ===
																	0
																}
															/>
															{lang.t("No Restrictions")}
															<Tooltip
																content={lang.t(
																	"The officer will see all jobs",
																)}
															>
																<i className="rkf rkf-question-solid tooltip-icon" />
															</Tooltip>
														</label>
													</div>
													<div className="radio radio-group">
														<label htmlFor="job-restriction-20">
															<input
																type="radio"
																name="job-restriction-options"
																id="job-restriction-20"
																onChange={this.handleJobRestrictionTypeChange(
																	20,
																)}
																checked={
																	officerRules.JobRestrictionType ===
																	20
																}
															/>
															{lang.t(
																"Only allow jobs in these cities/counties",
															)}
															<Tooltip
																content={lang.t(
																	"The officer will only see jobs on allowed locations",
																)}
															>
																<i className="rkf rkf-question-solid tooltip-icon" />
															</Tooltip>
														</label>
													</div>
													<div className="radio radio-group">
														<label htmlFor="job-restriction-30">
															<input
																type="radio"
																name="job-restriction-options"
																id="job-restriction-30"
																onChange={this.handleJobRestrictionTypeChange(
																	30,
																)}
																checked={
																	officerRules.JobRestrictionType ===
																	30
																}
															/>
															{lang.t(
																"Only allow jobs created by my agency",
															)}
															<Tooltip
																content={lang.t(
																	"The officer will only see and apply to jobs created by your agency",
																)}
															>
																<i className="rkf rkf-question-solid tooltip-icon" />
															</Tooltip>
														</label>
													</div>

													<If
														condition={
															officerRules.JobRestrictionType === 20
														}
													>
														<div className="row collapsing-panel-header">
															<div className="col-xs-7 col-sm-8 title">
																<div>
																	{lang.t("Allowed Locations")}
																</div>
															</div>
															<div className="col-xs-3 text-right">
																<button
																	type="button"
																	className="btn btn-link"
																	onClick={() =>
																		this.handleLocationAdd()
																	}
																>
																	<span className="visible-xs">{`+ ${lang.t("Add")}`}</span>
																	<span className="hidden-xs">{`+ ${lang.t("Add Location")}`}</span>
																</button>
															</div>
															<div className="col-xs-2 col-sm-1 text-right">
																<button
																	type="button"
																	className="btn btn-link"
																	onClick={() =>
																		this.toggleAllowedLocations()
																	}
																	title={
																		showAllowedLocations
																			? "Hide location rules"
																			: "Show location rules"
																	}
																>
																	<i
																		className={`rkf ${showAllowedLocations ? "rkf-chevron-up" : "rkf-chevron-down"}`}
																	/>
																</button>
															</div>
														</div>
														<div
															className={`container-fluid collapsing-panel${showAllowedLocations ? " expanded" : ""}`}
														>
															<If
																condition={
																	officerRules.JobRestrictionType
																}
															>
																<div className="row">
																	<div className="col-xs-12 text-muted text-center">
																		{lang.t(
																			"You have not specified any restricted locations",
																		)}
																	</div>
																</div>
															</If>
															<For
																each="loc"
																of={allowedLocations}
																index="index"
															>
																<div
																	className="row"
																	key={`location-restriction-${loc.label}`}
																>
																	<div className="col-xs-2">
																		<span className="badge">
																			{loc.type}
																		</span>
																	</div>
																	<div className="col-xs-8">
																		<AsyncSelect
																			id={`location-restriction-${loc.label}`}
																			placeholder={lang.t(
																				"Search Location",
																			)}
																			cacheOptions
																			loadOptions={
																				this.searchLocations
																			}
																			value={
																				loc.label !== ""
																					? loc
																					: undefined
																			}
																			onChange={this.handleLocationUpdate(
																				index,
																			)}
																			noOptionsMessage={({
																				inputValue,
																			}) =>
																				inputValue
																					? lang.t(
																							"Location not found",
																						)
																					: lang.t(
																							"Please type a location name in order to see options",
																						)
																			}
																		/>
																	</div>
																	<div className="col-xs-2 text-center">
																		<button
																			type="button"
																			className="btn btn-link"
																			onClick={this.handleLocationUpdate(
																				index,
																				true,
																			)}
																		>
																			<i className="rkf rkf-trash text-danger" />
																		</button>
																	</div>
																</div>
															</For>
														</div>
													</If>
												</div>
											</div>
										</div>
									</When>
								</Choose>
							</div>
							<div className={step === 4 ? "hidden" : "row"}>
								<div className="col-xs-12 signup-form-footer">
									<div className="col-xs-6 text-left">
										<button
											type="button"
											className={step === 0 ? "hidden" : "btn btn-link"}
											onClick={() => this.skipStep(step)}
										>
											{step === 1 ? "Back" : "Skip"}
										</button>
									</div>
									<div className="col-xs-6 text-right">
										<Choose>
											<When condition={step === 1}>
												<ProgressButton
													id="button-departmentInfo"
													className="btn btn-primary continue-button"
													state={buttonState}
													onClick={() => this.handleDepartmentInfo()}
												>
													{lang.t("Continue")}
													&nbsp;
													<i className="rkf rkf-arrow-right" />
												</ProgressButton>
											</When>
											<When condition={step === 2 && subStep === 1}>
												<ProgressButton
													id="button-BankAccountInfo"
													className="btn btn-primary continue-button"
													state={buttonState}
													onClick={() => this.handleBankAccountInfo()}
												>
													{lang.t("Continue")}
													&nbsp;
													<i className="rkf rkf-arrow-right" />
												</ProgressButton>
											</When>
											<When condition={step === 2 && subStep === 2}>
												<ProgressButton
													id="button-InvoiceInfo"
													className="btn btn-primary continue-button"
													state={buttonState}
													onClick={() => this.handleInvoiceInfo()}
												>
													{lang.t("Continue")}
													&nbsp;
													<i className="rkf rkf-arrow-right" />
												</ProgressButton>
											</When>
											<When condition={step === 3 && subStep === 1}>
												<ProgressButton
													id="button-AgencyRules"
													className="btn btn-primary continue-button"
													state={buttonState}
													onClick={() => this.handleAgencyRules()}
												>
													{lang.t("Continue")}
													&nbsp;
													<i className="rkf rkf-arrow-right" />
												</ProgressButton>
											</When>
											<When condition={step === 3 && subStep === 2}>
												<ProgressButton
													id="button-OfficerRules"
													className="btn btn-primary continue-button"
													state={buttonState}
													onClick={() => this.handleOfficerRules()}
												>
													{lang.t("Continue")}
													&nbsp;
													<i className="rkf rkf-arrow-right" />
												</ProgressButton>
											</When>
											<Otherwise>
												<ProgressButton
													id="button-personalInfo"
													className="btn btn-primary continue-button"
													state={buttonState}
													onClick={() => this.handlePersonalInfo()}
												>
													{lang.t("Continue")}
													&nbsp;
													<i className="rkf rkf-arrow-right" />
												</ProgressButton>
											</Otherwise>
										</Choose>
									</div>
								</div>
							</div>
							<Choose>
								<When condition={step === 4}>
									<div className="text-center signup-lea-confirmation">
										<div className="confirm-heading">
											<h1>{lang.t("You are all set!")}</h1>
										</div>
										<p>{lang.t("Your LEA account is now setup")}</p>
										<p>
											{`${lang.t("Thank you for your submission_")}
											${lang.t("An email has been sent to verify your email address_")}
											${lang.t("You are also currently in our queue to verify your information_")}
											${lang.t("You will receive an email when your account has been verified and activated within the next 2-3 business days_")}
											`}
										</p>
										<div>
											<a
												href={STATIC_URLS.rootUrl}
												className="btn btn-primary exit-button"
											>
												<span>{lang.t("Go to rollkall dot com")}</span>
											</a>
										</div>
									</div>
								</When>
							</Choose>
						</div>

						<div
							className={classNames(
								"signup-rollkall-promo text-center col-sm-5 hidden-xs",
								{ hidden: step === 4 || step === 3 || subStep === 2 },
							)}
						>
							<div className="text-center">
								<div className="promo-image">
									<Image
										className="img-responsive"
										src="/images/rollkall_promo_1.png"
										alt="promo image"
									/>
								</div>
								<div className="promo-text text-left">
									<h2>{lang.t("RollKall For LEA")}</h2>
									<p>
										{lang.t(
											"Great benefits await by using RollKall, including",
										)}
									</p>
									<ol>
										<li>{lang.t("Manage all of your officers")}</li>
										<li>{lang.t("Approve or decline requests")}</li>
										<li>{lang.t("Approve payments easily")}</li>
									</ol>
								</div>
							</div>
						</div>

						{/* signup-lea-form */}
					</div>
					{/* signup-lea-form */}
				</div>
				{/* signup-lea-container */}
				<CreateJurisdictionModal
					show={showJurisdictionModal}
					onSuccess={data => {
						this.closeJurisdictionModal();
						this.setNewDepartment(data);
					}}
					onClose={this.closeJurisdictionModal}
				/>
			</div>
		);
	}
}

SignUpLea.propTypes = {
	location: PropTypes.object,
};

SignUpLea.defaultProps = {
	location: {},
};

export default SignUpLea;
